export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Booleans represented as a yes/no string */
  StringBool: string;
  /** Dates stored as strings */
  StringDate: string;
  /** Floats represented as string */
  StringFloat: string;
  Url: any;
};

export type Achievement = {
  __typename?: 'Achievement';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  type: AchievementType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
};

export enum AchievementType {
  Photographer = 'Photographer',
  SuperTester = 'SuperTester'
}

export type AddOrRemoveListBrandResponse = {
  __typename?: 'AddOrRemoveListBrandResponse';
  brand: Brand;
  list: List;
  result: AddOrRemoveResult;
};

export enum AddOrRemoveResult {
  Added = 'Added',
  Removed = 'Removed'
}

export type BagShippingMethod = {
  __typename?: 'BagShippingMethod';
  bag_id: Scalars['Int'];
  carrier?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  shipping_method_id: Scalars['String'];
  tracking_number?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BagShippingMethods = {
  __typename?: 'BagShippingMethods';
  bag_id: Scalars['Int'];
  shipping_methods: Array<BagShippingMethod>;
};

export type BetaTesterInvite = {
  __typename?: 'BetaTesterInvite';
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type BetaTesterInviteResponse = {
  __typename?: 'BetaTesterInviteResponse';
  betaTesterInvite?: Maybe<BetaTesterInvite>;
  user?: Maybe<User>;
};

export type Brand = {
  __typename?: 'Brand';
  addedBy: User;
  alternativeWebUrls: Array<Scalars['String']>;
  assetsFolder: Scalars['String'];
  availableSubscriptionPlans: Array<SubscriptionPlan>;
  categories: Array<Category>;
  categoryIds: Array<Scalars['Int']>;
  categoryTags: Scalars['JSON'];
  claimed: Scalars['Boolean'];
  company?: Maybe<BrandCompanyData>;
  contributorLeads: Array<ContributorLead>;
  contributors: Array<Contributor>;
  createdAt: Scalars['DateTime'];
  demographics: Scalars['JSON'];
  description?: Maybe<Scalars['String']>;
  descriptionFromBrand?: Maybe<Scalars['String']>;
  discountCodes?: Maybe<Array<DiscountCode>>;
  externalLinks?: Maybe<Array<ExternalLink>>;
  hasDiscountCodes: Scalars['Boolean'];
  hasPublicDiscountCodes: Scalars['Boolean'];
  id: Scalars['ID'];
  impactInitiatives?: Maybe<Scalars['String']>;
  instagramReviewUrl?: Maybe<Scalars['String']>;
  internalTags: Array<Scalars['String']>;
  isPromoted?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  lastContributionAt?: Maybe<Scalars['DateTime']>;
  likesCount: Scalars['Int'];
  lists: Array<List>;
  merchant: Merchant;
  milestones: Array<BrandMilestone>;
  mostRecentSortOrderWeight?: Maybe<BrandSortOrderWeightHistory>;
  myReview?: Maybe<Review>;
  people?: Maybe<BrandPeopleData>;
  primaryImageCredit?: Maybe<Scalars['String']>;
  primaryImageFullPath?: Maybe<Scalars['String']>;
  primaryImageProminentColorHex?: Maybe<Scalars['String']>;
  primaryImageUploaderType?: Maybe<PrimaryImageUploaderType>;
  privateFeedback: ReviewsResponse;
  productDrops: Array<ProductDrop>;
  products: Array<Product>;
  promotedProductOfferCampaign?: Maybe<ProductOfferCampaign>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  relatedBrands: RelatedBrandsResponse;
  reviewAiSummary?: Maybe<ReviewAiSummary>;
  reviewSummary?: Maybe<ReviewSummary>;
  reviewableProducts: Array<BrandProduct>;
  reviews: ReviewsResponse;
  revisions: Array<BrandRevision>;
  rip: Scalars['Boolean'];
  rooms: Scalars['JSON'];
  secondaryImageIds: Array<Scalars['Int']>;
  secondaryImages: Array<MediaUpload>;
  shipsTo: Scalars['JSON'];
  shopifyConnection?: Maybe<ShopifyConnection>;
  slug: Scalars['String'];
  slugHistory: Scalars['JSON'];
  sortOrderWeight: Scalars['Float'];
  sortOrderWeightBreakdown: Scalars['JSON'];
  sortOrderWeightHistory: Array<BrandSortOrderWeightHistory>;
  status: BrandStatus;
  stories: Array<Story>;
  subcategories: Scalars['JSON'];
  subscriptions: Array<BrandSubscription>;
  tags: Scalars['JSON'];
  title: Scalars['String'];
  titleTag?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  verificationStatus: BrandVerificationStatus;
  webUrl?: Maybe<Scalars['String']>;
  webUrlDomain?: Maybe<Scalars['String']>;
};


export type BrandPrivateFeedbackArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type BrandProductDropsArgs = {
  filter?: InputMaybe<ProductDropFilter>;
};


export type BrandRelatedBrandsArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type BrandReviewableProductsArgs = {
  onlyWithReviews?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<BrandProductSortOrder>;
};


export type BrandReviewsArgs = {
  brandProductIds?: InputMaybe<Array<Scalars['ID']>>;
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  order?: InputMaybe<ReviewSortOrder>;
  ratings?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type BrandStoriesArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
};


export type BrandSubscriptionsArgs = {
  includeAutoApplied?: InputMaybe<Scalars['Boolean']>;
};

export type BrandCompanyData = {
  __typename?: 'BrandCompanyData';
  certificates?: Maybe<Array<Scalars['String']>>;
  dateFounded?: Maybe<Scalars['String']>;
  dateLaunched?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['Url']>;
  hqGps?: Maybe<GeoCoordinate>;
  hqLocation?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['Url']>;
  pintrestUrl?: Maybe<Scalars['Url']>;
  retail?: Maybe<Scalars['Boolean']>;
  tiktokUrl?: Maybe<Scalars['Url']>;
  twitter?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['Url']>;
};

export type BrandCompanyDataInput = {
  certificates?: InputMaybe<Array<Scalars['String']>>;
  dateFounded?: InputMaybe<Scalars['String']>;
  dateLaunched?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['Url']>;
  hqGps?: InputMaybe<GeoCoordinateInput>;
  hqLocation?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['Url']>;
  pintrestUrl?: InputMaybe<Scalars['Url']>;
  retail?: InputMaybe<Scalars['Boolean']>;
  tiktokUrl?: InputMaybe<Scalars['Url']>;
  twitter?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['Url']>;
};

export type BrandCoordinates = {
  __typename?: 'BrandCoordinates';
  coordinates: GeoCoordinate;
  id: Scalars['ID'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type BrandEditSuggestion = {
  __typename?: 'BrandEditSuggestion';
  appliedInputSnapshot?: Maybe<Scalars['JSON']>;
  brand: Brand;
  brandSnapshot?: Maybe<Scalars['JSON']>;
  contributor?: Maybe<Contributor>;
  createdAt: Scalars['DateTime'];
  edits?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  status: BrandEditSuggestionStatus;
  updatedAt: Scalars['DateTime'];
  user: User;
};

export enum BrandEditSuggestionStatus {
  Applied = 'Applied',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export enum BrandFilterStatus {
  Any = 'Any',
  Archived = 'Archived',
  Published = 'Published',
  Rejected = 'Rejected',
  ToScreen = 'ToScreen',
  Track = 'Track'
}

export type BrandInput = {
  alternativeWebUrls?: InputMaybe<Array<Scalars['String']>>;
  brandProductIds?: InputMaybe<Array<Scalars['Int']>>;
  brandProducts?: InputMaybe<Array<BrandProductInput>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  company?: InputMaybe<BrandCompanyDataInput>;
  demographics?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionFromBrand?: InputMaybe<Scalars['String']>;
  discountCodes?: InputMaybe<Array<DiscountCodeInput>>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  impactInitiatives?: InputMaybe<Scalars['String']>;
  instagramReviewUrl?: InputMaybe<Scalars['String']>;
  internalTags?: InputMaybe<Scalars['JSON']>;
  keywords?: InputMaybe<Scalars['String']>;
  merchantConnectionEnabled?: InputMaybe<Scalars['Boolean']>;
  people?: InputMaybe<BrandPeopleDataInput>;
  primaryImageCredit?: InputMaybe<Scalars['String']>;
  primaryImageFullPath?: InputMaybe<Scalars['String']>;
  primaryImageName?: InputMaybe<Scalars['String']>;
  rip?: InputMaybe<Scalars['Boolean']>;
  rooms?: InputMaybe<Scalars['JSON']>;
  secondaryImages?: InputMaybe<Array<MediaUploadInput>>;
  shipsTo?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BrandStatus>;
  tags?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
  webUrl?: InputMaybe<Scalars['Url']>;
};

export type BrandListStatistic = {
  __typename?: 'BrandListStatistic';
  id: Scalars['ID'];
  numberOfLists: Scalars['Int'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type BrandMetadataSummary = {
  __typename?: 'BrandMetadataSummary';
  categories: Array<Scalars['String']>;
  companyCertificates: Array<Scalars['String']>;
  demographics: Array<Scalars['String']>;
  founderDemographics: Array<Scalars['String']>;
  internalTags: Array<Scalars['String']>;
  rooms: Array<Scalars['String']>;
  subcategories: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
};


export type BrandMetadataSummarySubcategoriesArgs = {
  fromCategories?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandMilestone = {
  __typename?: 'BrandMilestone';
  completedAt: Scalars['StringDate'];
  type: BrandMilestoneType;
};

export enum BrandMilestoneType {
  BestOf = 'BestOf'
}

export type BrandPeopleData = {
  __typename?: 'BrandPeopleData';
  demographics?: Maybe<Array<Scalars['String']>>;
  founders?: Maybe<Array<Person>>;
};

export type BrandPeopleDataInput = {
  demographics?: InputMaybe<Array<Scalars['String']>>;
  founders?: InputMaybe<Array<PersonInput>>;
};

export type BrandProduct = {
  __typename?: 'BrandProduct';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  numberOfReviews: Scalars['Int'];
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BrandProductInput = {
  name: Scalars['String'];
};

export enum BrandProductSortOrder {
  Popular = 'Popular'
}

export type BrandRevision = {
  __typename?: 'BrandRevision';
  authorizedByUser?: Maybe<User>;
  brand: Brand;
  createdAt: Scalars['DateTime'];
  delta: Scalars['JSON'];
  edits: Scalars['JSON'];
  id: Scalars['ID'];
  snapshot: Scalars['JSON'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type BrandRevisionsResponse = {
  __typename?: 'BrandRevisionsResponse';
  hasMore: Scalars['Boolean'];
  items: Array<BrandRevision>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum BrandSortOrder {
  Added = 'Added',
  AtoZ = 'AtoZ',
  Created = 'Created',
  LastReviewed = 'LastReviewed',
  Latest = 'Latest',
  Launched = 'Launched',
  MostReviewed = 'MostReviewed',
  Recommended = 'Recommended'
}

export type BrandSortOrderWeightHistory = {
  __typename?: 'BrandSortOrderWeightHistory';
  brand: Brand;
  brandsCount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  position: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  weight: Scalars['Float'];
  weightBreakdown: Scalars['JSON'];
};

export enum BrandStatus {
  Archived = 'Archived',
  Published = 'Published',
  Rejected = 'Rejected',
  ToScreen = 'ToScreen',
  Track = 'Track'
}

export type BrandSubmissionInput = {
  duplicateOfRelatedBrand?: InputMaybe<Scalars['Boolean']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  relationshipToBrand: BrandUserRelationship;
  title: Scalars['String'];
  webUrl: Scalars['Url'];
};

export type BrandSubmissionResult = {
  __typename?: 'BrandSubmissionResult';
  brand: Brand;
  duplicateHasBeenLogged?: Maybe<Scalars['Boolean']>;
  eligibleToContribute: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  isPotentialDuplicate?: Maybe<Scalars['Boolean']>;
};

export type BrandSubscription = {
  __typename?: 'BrandSubscription';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invoices: Array<StripeInvoice>;
  stripeSubscription?: Maybe<StripeSubscription>;
  subscriptionPlan: SubscriptionPlan;
  updatedAt: Scalars['DateTime'];
};

export enum BrandUserRelationship {
  Customer = 'Customer',
  Employee = 'Employee',
  Founder = 'Founder',
  Other = 'Other',
  PublicRelations = 'PublicRelations'
}

export enum BrandVerificationStatus {
  Applied = 'Applied',
  Unclaimed = 'Unclaimed',
  Verified = 'Verified'
}

export enum BrandVerificationStatusFilter {
  Any = 'Any',
  Applied = 'Applied',
  Unclaimed = 'Unclaimed',
  Verified = 'Verified'
}

export type BrandsResponse = {
  __typename?: 'BrandsResponse';
  hasMore: Scalars['Boolean'];
  items: Array<Brand>;
  nextSkip: Scalars['Int'];
  queryID?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type Cart = {
  __typename?: 'Cart';
  allBagsComplete: Scalars['Boolean'];
  bags: Array<CartBag>;
  billingAddress?: Maybe<CartShippingAddress>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  currencySymbol?: Maybe<Scalars['String']>;
  customer?: Maybe<CartCustomer>;
  errors: Array<Scalars['String']>;
  hasPhysicalVariants: Scalars['Boolean'];
  id: Scalars['ID'];
  isPriced: Scalars['Boolean'];
  merchants: Array<Merchant>;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<CartShippingAddress>;
  shippingCountries: Array<ShippingCountry>;
  shippingTotal?: Maybe<Scalars['Int']>;
  skuIds: Array<Scalars['String']>;
  status: Scalars['String'];
  stripePublicKey?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Int']>;
  taxTotal?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  variantTypes: Array<Scalars['String']>;
  violetCartId?: Maybe<Scalars['ID']>;
};

export type CartBag = {
  __typename?: 'CartBag';
  id: Scalars['Int'];
  merchant?: Maybe<Merchant>;
  merchant_id?: Maybe<Scalars['ID']>;
  merchant_name: Scalars['String'];
  shipping_method?: Maybe<CartBagShippingMethod>;
  skus: Array<CartBagSku>;
  status: Scalars['String'];
};

export type CartBagShippingMethod = {
  __typename?: 'CartBagShippingMethod';
  carrier?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  shipping_method_id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type CartBagSku = {
  __typename?: 'CartBagSku';
  brand: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  line_price?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  productVariant?: Maybe<ProductVariant>;
  product_type?: Maybe<ProductType>;
  quantity: Scalars['Int'];
  retail_price?: Maybe<Scalars['Int']>;
  sale_price?: Maybe<Scalars['Int']>;
  sku_id: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
};

export type CartCustomer = {
  __typename?: 'CartCustomer';
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
};

export type CartCustomerInput = {
  address_1: Scalars['String'];
  address_2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  postal_code: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type CartShippingAddress = {
  __typename?: 'CartShippingAddress';
  address_1: Scalars['String'];
  address_2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type CartSkuUpdateInput = {
  productVariantId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type Category = {
  __typename?: 'Category';
  children?: Maybe<Array<Category>>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metaDescription?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parent?: Maybe<Category>;
  parentId?: Maybe<Scalars['Float']>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CheckoutSessionAdditionalProduct = {
  id: Scalars['ID'];
  price: Scalars['Int'];
};

export type Contributor = {
  __typename?: 'Contributor';
  brand: Brand;
  brandId: Scalars['Float'];
  contributorApplication?: Maybe<ContributorApplication>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  relationshipToBrand?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Float'];
};

export type ContributorApplication = {
  __typename?: 'ContributorApplication';
  approvalToken?: Maybe<Scalars['String']>;
  brand: Brand;
  brandId: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  linkedInUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  relationshipToBrand: Scalars['String'];
  status: ContributorApplicationStatus;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Float'];
};

export type ContributorApplicationInput = {
  brandId: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  linkedInUrl?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  relationshipToBrand?: InputMaybe<Scalars['String']>;
};

export enum ContributorApplicationStatus {
  Approved = 'Approved',
  Denied = 'Denied',
  PendingEmailConfirmation = 'PendingEmailConfirmation',
  PendingReview = 'PendingReview',
  Postponed = 'Postponed'
}

export type ContributorLead = {
  __typename?: 'ContributorLead';
  addedByUser: User;
  addedByUserId: Scalars['Int'];
  brand: Brand;
  brandId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type ContributorLeadInput = {
  brandId: Scalars['Float'];
  email: Scalars['String'];
};

export type ContributorsResponse = {
  __typename?: 'ContributorsResponse';
  hasMore: Scalars['Boolean'];
  items: Array<Contributor>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CreatePurchaseReceiptInput = {
  mediaUploads: Array<MediaUploadInput>;
  purchaseId: Scalars['ID'];
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  code: Scalars['String'];
  expiryDate?: Maybe<Scalars['StringDate']>;
  limitToSupertesters?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type DiscountCodeInput = {
  code: Scalars['String'];
  expiryDate?: InputMaybe<Scalars['StringDate']>;
  limitToSupertesters?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  imageUrl?: Maybe<Scalars['String']>;
  storageId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ExternalLinkData = {
  __typename?: 'ExternalLinkData';
  charset?: Maybe<Scalars['String']>;
  complete: Scalars['Boolean'];
  id: Scalars['ID'];
  imageStorageRef?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  ogDescription?: Maybe<Scalars['String']>;
  ogImage?: Maybe<ExternalLinkOgImage>;
  ogLocale?: Maybe<Scalars['String']>;
  ogTitle?: Maybe<Scalars['String']>;
  requestUrl: Scalars['String'];
  success: Scalars['Boolean'];
  updatedAt: Scalars['Int'];
};

export type ExternalLinkInput = {
  imageUrl?: InputMaybe<Scalars['String']>;
  storageId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ExternalLinkOgImage = {
  __typename?: 'ExternalLinkOgImage';
  type: Scalars['String'];
  url: Scalars['String'];
};

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  NonBinary = 'NonBinary',
  None = 'None',
  Other = 'Other'
}

export type GeoCoordinate = {
  __typename?: 'GeoCoordinate';
  latitude?: Maybe<Scalars['StringFloat']>;
  longitude?: Maybe<Scalars['StringFloat']>;
};

export type GeoCoordinateInput = {
  latitude?: InputMaybe<Scalars['StringFloat']>;
  longitude?: InputMaybe<Scalars['StringFloat']>;
};

export type KarmaAmount = {
  __typename?: 'KarmaAmount';
  ADDED_AN_AVATAR: Scalars['Int'];
  ADDED_A_BIO: Scalars['Int'];
  ADDED_A_SOCIAL_LINK: Scalars['Int'];
  ADDED_LOCATION: Scalars['Int'];
  ADDED_MEDIA_IN_REVIEW: Scalars['Int'];
  ADDED_RATING_ONLY_REVIEW: Scalars['Int'];
  CREATED_AN_ACCOUNT: Scalars['Int'];
  CREATED_A_CUSTOM_LIST_WITH_FIVE_BRANDS: Scalars['Int'];
  FIRST_REVIEWER_OF_BRAND: Scalars['Int'];
  REVIEWED_THINGDROP: Scalars['Int'];
  REVIEW_CLAPPED: Scalars['Int'];
  REVIEW_CLAPPED_ANONYMOUSLY: Scalars['Int'];
  SPOTTED_A_PUBLISHED_BRAND: Scalars['Int'];
  SUBMITTED_A_SUCCESSFUL_REPORT: Scalars['Int'];
  VERIFIED_ACCOUNT: Scalars['Int'];
  VIOLATING_REVIEW_REMOVED: Scalars['Int'];
  WROTE_A_REVIEW_WHEN_SPOTTING_BRAND: Scalars['Int'];
  WROTE_LONG_FORM_REVIEW: Scalars['Int'];
  WROTE_REVIEW: Scalars['Int'];
};

export type List = {
  __typename?: 'List';
  brands: ListBrandsResponse;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** If the list was fetched with a brandId, this will indicate if the list includes that brand */
  includesBrand: Scalars['Boolean'];
  isFeatured: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  isSpecial: Scalars['Boolean'];
  title: Scalars['String'];
  type: ListType;
  updatedAt: Scalars['DateTime'];
  user: User;
};


export type ListBrandsArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
  isReviewed?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ListBrandsResponse = {
  __typename?: 'ListBrandsResponse';
  hasMore: Scalars['Boolean'];
  items: Array<Brand>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ListInput = {
  description?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum ListType {
  Dismissed = 'Dismissed',
  Generated = 'Generated',
  Spotted = 'Spotted',
  Tested = 'Tested',
  UserCreated = 'UserCreated',
  Viewed = 'Viewed',
  WantToTest = 'WantToTest'
}

export type MediaUpload = {
  __typename?: 'MediaUpload';
  caption?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credit?: Maybe<Scalars['String']>;
  filePath: Scalars['String'];
  id: Scalars['ID'];
  purchaseReceiptValidation?: Maybe<PurchaseReceiptMediaValidation>;
  transformationStatus: MediaUploadTransformationStatus;
  type: MediaUploadType;
  updatedAt: Scalars['DateTime'];
  urlTemplate: Scalars['String'];
};

export type MediaUploadInput = {
  caption?: InputMaybe<Scalars['String']>;
  credit?: InputMaybe<Scalars['String']>;
  filePath?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum MediaUploadTransformationStatus {
  Accepted = 'Accepted',
  Error = 'Error',
  Ready = 'Ready',
  Unknown = 'Unknown'
}

export enum MediaUploadType {
  Image = 'Image',
  Video = 'Video'
}

export enum MembershipLevel {
  Friend = 'Friend',
  None = 'None'
}

export type Merchant = {
  __typename?: 'Merchant';
  brand: Brand;
  connectionHealth: MerchantHealth;
  connectionNonce: Scalars['String'];
  createdAt: Scalars['DateTime'];
  externalConnectionUrl: Scalars['String'];
  id: Scalars['ID'];
  status: MerchantConnectionStatus;
  storeUrl?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  supportUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum MerchantConnectionStatus {
  Connected = 'Connected',
  NotConnected = 'NotConnected'
}

export type MerchantHealth = {
  __typename?: 'MerchantHealth';
  commission_rate: Scalars['String'];
  connection: Scalars['String'];
  invalid_products: Scalars['String'];
  migration_account: Scalars['String'];
  payout_account: Scalars['String'];
  scope_validation: Scalars['String'];
  sync_status: Scalars['String'];
};

export type MerchantInput = {
  supportEmail: Scalars['String'];
  supportUrl: Scalars['String'];
};

export type MerchantProductsResponse = {
  __typename?: 'MerchantProductsResponse';
  hasMore: Scalars['Boolean'];
  items: Array<RawProduct>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Milestone = {
  __typename?: 'Milestone';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeAllReviewReports: Array<ReviewReport>;
  addOrRemoveBrandFromList: AddOrRemoveListBrandResponse;
  applyBrandEditSuggestion: BrandEditSuggestion;
  changeContributorApplicationStatus: ContributorApplication;
  changeEmailAddress: User;
  connectMerchantProduct: Product;
  consumeInvitation: SuccessResponse;
  createBetaTesterInvite: BetaTesterInviteResponse;
  createBrand: Brand;
  createBrandEditSuggestion: BrandEditSuggestion;
  createBrandSourcedUserBrandOwnership: SuccessResponse;
  createBrandSubscription: BrandSubscription;
  createBrandView: AddOrRemoveListBrandResponse;
  createCart: Cart;
  createContributorApplication: ContributorApplication;
  createContributorLead: ContributorLead;
  createCookieToken: SuccessResponse;
  createList: List;
  createMediaUpload: MediaUpload;
  createNotificationToken: SuccessResponse;
  createOrUpdateMerchant: Merchant;
  createProductDrop: ProductDrop;
  createPurchase: Purchase;
  createPurchaseReceipt: PurchaseReceipt;
  createReview: Review;
  createReviewReply: ReviewReply;
  /** @deprecated Use public key instead of generating new keys */
  createSearchApiKey: SuccessResponse;
  createSessionToken: SuccessResponse;
  createShippingReadinessCheck: ShippingReadinessCheck;
  createShopifyConnection: ShopifyConnection;
  createStory: Story;
  createSubscriptionCheckoutSession: StripeCheckoutSession;
  createTokenFromInvitation: SuccessResponse;
  deleteBrandSubscription: SuccessResponse;
  deleteList: SuccessResponse;
  deleteReviews: Array<Review>;
  fetchExternalLinkData: ExternalLinkData;
  finalizeMerchantConnection: Merchant;
  finalizeShopifyConnection: ShopifyConnection;
  getPaymentIntentClientSecret: Cart;
  moveMediaUploadToBrandAssetFolder: MediaUpload;
  refetchCart: Cart;
  rejectBrandEditSuggestion: BrandEditSuggestion;
  removeContributor: SuccessResponse;
  removeContributorLead: SuccessResponse;
  removeMe: SuccessResponse;
  removeReview: SuccessResponse;
  removeReviewReply: SuccessResponse;
  reportReview: SuccessResponse;
  restoreReviews: Array<Review>;
  /** @deprecated Deprecated in favor of 3D secure flow. Use 'selectShippingMethodsAndGetPaymentIntentSecret' instead */
  selectShippingMethods: Cart;
  selectShippingMethodsAndGetPaymentIntentSecret: Cart;
  setAvatar: User;
  submitBrand: BrandSubmissionResult;
  submitCart: Cart;
  toggleAcknowledgeReviewReport: ReportResponse;
  toggleListFeatured: List;
  toggleReviewReaction: ReactionResponse;
  unlinkPhoneNumber: User;
  updateBrand?: Maybe<Brand>;
  updateBrands: Array<Brand>;
  updateCart: Cart;
  updateCartCustomer: Cart;
  updateList: List;
  updateNotificationSettings: SuccessResponse;
  updateProductDrop: ProductDrop;
  updateProfile: User;
  updatePurchaseReceipt: PurchaseReceipt;
  updateReview: Review;
  updateStory: Story;
  verifyPhoneNumber: User;
};


export type MutationAcknowledgeAllReviewReportsArgs = {
  reviewId: Scalars['ID'];
};


export type MutationAddOrRemoveBrandFromListArgs = {
  brandId: Scalars['ID'];
  listId?: InputMaybe<Scalars['Int']>;
  listType?: InputMaybe<ListType>;
};


export type MutationApplyBrandEditSuggestionArgs = {
  brandId: Scalars['Int'];
  id: Scalars['Int'];
  input: BrandInput;
};


export type MutationChangeContributorApplicationStatusArgs = {
  id: Scalars['Int'];
  status: ContributorApplicationStatus;
};


export type MutationChangeEmailAddressArgs = {
  newEmail: Scalars['String'];
};


export type MutationConnectMerchantProductArgs = {
  brandId: Scalars['ID'];
  merchantOfferId?: InputMaybe<Scalars['ID']>;
  merchantProductId?: InputMaybe<Scalars['ID']>;
};


export type MutationConsumeInvitationArgs = {
  token: Scalars['String'];
};


export type MutationCreateBetaTesterInviteArgs = {
  email: Scalars['String'];
};


export type MutationCreateBrandArgs = {
  assetsFolder: Scalars['String'];
  input: BrandInput;
};


export type MutationCreateBrandEditSuggestionArgs = {
  id: Scalars['Int'];
  input: BrandInput;
};


export type MutationCreateBrandSourcedUserBrandOwnershipArgs = {
  brandId: Scalars['ID'];
};


export type MutationCreateBrandSubscriptionArgs = {
  brandId: Scalars['ID'];
  subscriptionPlanId: Scalars['ID'];
};


export type MutationCreateBrandViewArgs = {
  brandId: Scalars['ID'];
};


export type MutationCreateCartArgs = {
  productVariants: Array<CartSkuUpdateInput>;
};


export type MutationCreateContributorApplicationArgs = {
  input: ContributorApplicationInput;
};


export type MutationCreateContributorLeadArgs = {
  input: ContributorLeadInput;
};


export type MutationCreateListArgs = {
  input: ListInput;
};


export type MutationCreateMediaUploadArgs = {
  filePath: Scalars['String'];
  type?: InputMaybe<MediaUploadType>;
};


export type MutationCreateOrUpdateMerchantArgs = {
  brandId: Scalars['ID'];
  input: MerchantInput;
};


export type MutationCreateProductDropArgs = {
  brandId: Scalars['ID'];
  input: ProductDropInput;
};


export type MutationCreatePurchaseArgs = {
  productId: Scalars['ID'];
  productOfferCampaignId: Scalars['ID'];
};


export type MutationCreatePurchaseReceiptArgs = {
  input: CreatePurchaseReceiptInput;
};


export type MutationCreateReviewArgs = {
  brandId: Scalars['ID'];
  input: ReviewInput;
};


export type MutationCreateReviewReplyArgs = {
  body?: InputMaybe<Scalars['String']>;
  reviewId: Scalars['ID'];
  type: ReplyType;
};


export type MutationCreateSessionTokenArgs = {
  email: Scalars['String'];
};


export type MutationCreateShippingReadinessCheckArgs = {
  productVariantID: Scalars['ID'];
};


export type MutationCreateShopifyConnectionArgs = {
  input: ShopifyConnectionInput;
};


export type MutationCreateStoryArgs = {
  input?: InputMaybe<StoryInput>;
};


export type MutationCreateSubscriptionCheckoutSessionArgs = {
  additionalProduct?: InputMaybe<CheckoutSessionAdditionalProduct>;
  brandId: Scalars['ID'];
  priceId: Scalars['ID'];
  subscriptionPlanId: Scalars['ID'];
};


export type MutationCreateTokenFromInvitationArgs = {
  token: Scalars['String'];
};


export type MutationDeleteBrandSubscriptionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteListArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteReviewsArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationFetchExternalLinkDataArgs = {
  url: Scalars['String'];
};


export type MutationFinalizeMerchantConnectionArgs = {
  connectionNonce: Scalars['String'];
  merchantId: Scalars['Int'];
};


export type MutationFinalizeShopifyConnectionArgs = {
  input: ShopifyFinalizeConnectionInput;
};


export type MutationGetPaymentIntentClientSecretArgs = {
  cartId: Scalars['ID'];
};


export type MutationMoveMediaUploadToBrandAssetFolderArgs = {
  assetsFolder: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationRefetchCartArgs = {
  id: Scalars['ID'];
};


export type MutationRejectBrandEditSuggestionArgs = {
  brandId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationRemoveContributorArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveContributorLeadArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveReviewArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveReviewReplyArgs = {
  id: Scalars['ID'];
};


export type MutationReportReviewArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationRestoreReviewsArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationSelectShippingMethodsArgs = {
  cartId: Scalars['ID'];
  shippingMethods: Array<ShippingMethodInput>;
};


export type MutationSelectShippingMethodsAndGetPaymentIntentSecretArgs = {
  cartId: Scalars['ID'];
  shippingMethods: Array<ShippingMethodInput>;
};


export type MutationSetAvatarArgs = {
  mediaUploadId: Scalars['Int'];
};


export type MutationSubmitBrandArgs = {
  input: BrandSubmissionInput;
};


export type MutationSubmitCartArgs = {
  cartId: Scalars['ID'];
  paymentToken?: InputMaybe<Scalars['String']>;
};


export type MutationToggleAcknowledgeReviewReportArgs = {
  reportId: Scalars['ID'];
};


export type MutationToggleListFeaturedArgs = {
  id: Scalars['Int'];
};


export type MutationToggleReviewReactionArgs = {
  reactionType: ReactionType;
  reviewId: Scalars['ID'];
};


export type MutationUnlinkPhoneNumberArgs = {
  input: UserPhoneVerificationInput;
};


export type MutationUpdateBrandArgs = {
  id: Scalars['ID'];
  input: BrandInput;
};


export type MutationUpdateBrandsArgs = {
  ids: Array<Scalars['Int']>;
  input: BrandInput;
};


export type MutationUpdateCartArgs = {
  id: Scalars['ID'];
  productVariants: Array<CartSkuUpdateInput>;
};


export type MutationUpdateCartCustomerArgs = {
  id: Scalars['ID'];
  input: CartCustomerInput;
};


export type MutationUpdateListArgs = {
  id: Scalars['Int'];
  input: ListInput;
};


export type MutationUpdateNotificationSettingsArgs = {
  input: NotificationSettingsInput;
};


export type MutationUpdateProductDropArgs = {
  id: Scalars['ID'];
  input: ProductDropInput;
};


export type MutationUpdateProfileArgs = {
  input: UserProfileInput;
  validationScope?: InputMaybe<UserProfileInputScope>;
};


export type MutationUpdatePurchaseReceiptArgs = {
  id: Scalars['ID'];
  input: UpdatePurchaseReceiptInput;
};


export type MutationUpdateReviewArgs = {
  id: Scalars['ID'];
  input: ReviewInput;
};


export type MutationUpdateStoryArgs = {
  id: Scalars['Int'];
  input: StoryInput;
};


export type MutationVerifyPhoneNumberArgs = {
  input: UserPhoneVerificationInput;
};

export type NotificationSettingsInput = {
  notifications?: InputMaybe<Scalars['Boolean']>;
};

export type Person = {
  __typename?: 'Person';
  name: Scalars['String'];
};

export type PersonInput = {
  name: Scalars['String'];
};

export enum PrimaryImageUploaderType {
  Brand = 'Brand',
  Reviewer = 'Reviewer'
}

export type Product = {
  __typename?: 'Product';
  brand: Brand;
  brandId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  defaultImageUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  externalAdminUrl?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  extraInfoLabel?: Maybe<Scalars['String']>;
  extraInfoLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSoldOut: Scalars['Boolean'];
  maxPrice?: Maybe<Scalars['Int']>;
  maximumQuantitySellable?: Maybe<Scalars['Int']>;
  merchantOfferId?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of 'merchantOfferId' */
  merchantProductId?: Maybe<Scalars['String']>;
  minPrice?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  quantitySold?: Maybe<Scalars['Int']>;
  shippingCountries: Array<ShippingCountry>;
  updatedAt: Scalars['DateTime'];
  variants: Array<ProductVariant>;
  variantsMap: Array<ProductVariantMap>;
};

export type ProductDrop = {
  __typename?: 'ProductDrop';
  backgroundColor?: Maybe<Scalars['String']>;
  brand: Brand;
  brandId: Scalars['Float'];
  canParticipate: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dropsAt?: Maybe<Scalars['DateTime']>;
  hasDropped: Scalars['Boolean'];
  hasPurchased: Scalars['Boolean'];
  heroImageFullPath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPromoted: Scalars['Boolean'];
  isSoldOut: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  nextDropAt?: Maybe<Scalars['DateTime']>;
  position: Scalars['Int'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Float']>;
  shipsTo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  visibleAfter?: Maybe<Scalars['DateTime']>;
  visibleUntil?: Maybe<Scalars['DateTime']>;
};

export enum ProductDropFilter {
  All = 'All',
  Previous = 'Previous',
  Upcoming = 'Upcoming',
  Visible = 'Visible'
}

export type ProductDropInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  dropsAt?: InputMaybe<Scalars['DateTime']>;
  heroImageFullPath?: InputMaybe<Scalars['String']>;
  isPromoted: Scalars['Boolean'];
  position?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductInput>;
  productId?: InputMaybe<Scalars['ID']>;
  productVariants?: InputMaybe<Array<ProductVariantInput>>;
  shipsTo?: InputMaybe<Scalars['String']>;
  visibleAfter?: InputMaybe<Scalars['DateTime']>;
  visibleUntil?: InputMaybe<Scalars['DateTime']>;
};

export enum ProductDropSortOrder {
  Created = 'Created',
  Dropping = 'Dropping',
  DroppingDesc = 'DroppingDESC'
}

export type ProductInput = {
  maximumQuantitySellable?: InputMaybe<Scalars['Int']>;
  shippingCountries?: Array<ShippingCountryInput>;
};

export type ProductOffer = {
  __typename?: 'ProductOffer';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  product: Product;
  updatedAt: Scalars['DateTime'];
};

export type ProductOfferCampaign = {
  __typename?: 'ProductOfferCampaign';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  endsAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  imageFullPath?: Maybe<Scalars['String']>;
  logoFullPath?: Maybe<Scalars['String']>;
  productOffer: ProductOffer;
  steps: ProductOfferCampaignSteps;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ProductOfferCampaignStep = {
  __typename?: 'ProductOfferCampaignStep';
  ctaText?: Maybe<Scalars['String']>;
  ctaUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  header: Scalars['String'];
};

export type ProductOfferCampaignSteps = {
  __typename?: 'ProductOfferCampaignSteps';
  payment: ProductOfferCampaignStep;
  storeFinder: ProductOfferCampaignStep;
  upload: ProductOfferCampaignStep;
};

export type ProductOfferCampaignsResponse = {
  __typename?: 'ProductOfferCampaignsResponse';
  hasMore: Scalars['Boolean'];
  items: Array<ProductOfferCampaign>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ProductType {
  Digital = 'DIGITAL',
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

export type ProductVariant = {
  __typename?: 'ProductVariant';
  createdAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  inStock: Scalars['Boolean'];
  limitToSupertesters: Scalars['Boolean'];
  maximumQuantitySellable?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  primaryImageUrl?: Maybe<Scalars['String']>;
  product: Product;
  productId: Scalars['ID'];
  quantityAvailable: Scalars['Int'];
  retailPrice: Scalars['Int'];
  salePrice: Scalars['Int'];
  shippingReadinessChecks: Array<ShippingReadinessCheck>;
  sku: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variantValues: Array<ProductVariantValue>;
};

export type ProductVariantInput = {
  id: Scalars['ID'];
  limitToSupertesters: Scalars['Boolean'];
  maximumQuantitySellable?: InputMaybe<Scalars['Int']>;
};

export type ProductVariantMap = {
  __typename?: 'ProductVariantMap';
  display_order?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  values: Array<ProductVariantMapValue>;
  visual: Scalars['Boolean'];
};

export type ProductVariantMapValue = {
  __typename?: 'ProductVariantMapValue';
  display_order?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  sku_ids: Array<Scalars['Int']>;
};

export type ProductVariantValue = {
  __typename?: 'ProductVariantValue';
  value: Scalars['String'];
  variant: Scalars['String'];
};

export enum Pronoun {
  He = 'He',
  None = 'None',
  She = 'She',
  They = 'They'
}

export type Purchase = {
  __typename?: 'Purchase';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  product: Product;
  productOfferCampaign: ProductOfferCampaign;
  receipts: Array<PurchaseReceipt>;
  status: PurchaseStatus;
  updatedAt: Scalars['DateTime'];
};

export type PurchaseReceipt = {
  __typename?: 'PurchaseReceipt';
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  mediaUploads: Array<MediaUpload>;
  purchase: Purchase;
  receiptsWithSameImages: Array<PurchaseReceipt>;
  reimbursableValue?: Maybe<Scalars['Int']>;
  reimbursement?: Maybe<PurchaseReimbursement>;
  status: PurchaseReceiptStatus;
  totalValue?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  user: User;
};


export type PurchaseReceiptReceiptsWithSameImagesArgs = {
  status?: InputMaybe<PurchaseReceiptStatus>;
};

export type PurchaseReceiptMediaValidation = {
  __typename?: 'PurchaseReceiptMediaValidation';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lineItems: Array<ReceiptProductLineItem>;
  merchantAddress?: Maybe<Scalars['String']>;
  merchantCity?: Maybe<Scalars['String']>;
  merchantCountryCode?: Maybe<Scalars['String']>;
  merchantName?: Maybe<Scalars['String']>;
  merchantPostalCode?: Maybe<Scalars['String']>;
  merchantState?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum PurchaseReceiptStatus {
  PendingValidation = 'PendingValidation',
  Rejected = 'Rejected',
  Validated = 'Validated'
}

export type PurchaseReceiptsResponse = {
  __typename?: 'PurchaseReceiptsResponse';
  hasMore: Scalars['Boolean'];
  items: Array<PurchaseReceipt>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PurchaseReimbursement = {
  __typename?: 'PurchaseReimbursement';
  amount: Scalars['Int'];
  completedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  createdByUser: User;
  currency: Scalars['String'];
  id: Scalars['ID'];
  tremendousRedemptionUrl: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum PurchaseStatus {
  Completed = 'Completed',
  Interested = 'Interested',
  Planned = 'Planned'
}

export type Query = {
  __typename?: 'Query';
  availableTags: Array<Tag>;
  brand?: Maybe<Brand>;
  brandCoordinates: Array<BrandCoordinates>;
  brandEditSuggestion: BrandEditSuggestion;
  brandEditSuggestions: Array<BrandEditSuggestion>;
  brandListStatistics: Array<BrandListStatistic>;
  brandReviewReactions: Array<ReviewReaction>;
  brandRevisions: BrandRevisionsResponse;
  brands: BrandsResponse;
  cart: Cart;
  cartShippingMethods: Array<BagShippingMethods>;
  categories: Array<Category>;
  category?: Maybe<Category>;
  checkExternalLinkData: ExternalLinkData;
  contributorApplication?: Maybe<ContributorApplication>;
  contributorApplications: Array<ContributorApplication>;
  contributorLeads: Array<ContributorLead>;
  contributors: ContributorsResponse;
  editReview?: Maybe<Review>;
  eligibileToContributeToBrand: Scalars['Boolean'];
  featuredLists: Array<List>;
  findBrandRedirect?: Maybe<Brand>;
  karmaAmount: KarmaAmount;
  list?: Maybe<List>;
  lists: Array<List>;
  me?: Maybe<User>;
  mediaUpload: MediaUpload;
  merchant?: Maybe<Merchant>;
  merchantProducts: MerchantProductsResponse;
  metadataSummary: BrandMetadataSummary;
  myBrandOwnership?: Maybe<UserBrandOwnership>;
  myContributableBrands: Array<Brand>;
  popularBrands: Array<Brand>;
  product: Product;
  productDrop?: Maybe<ProductDrop>;
  /** Returns a list of product drops. The sort option is ignored in favor of [...dropping, ...upcoming, ...sold out] if the filter is set to Visible */
  productDrops: Array<ProductDrop>;
  productOfferCampaign: ProductOfferCampaign;
  productOfferCampaigns: ProductOfferCampaignsResponse;
  purchase: Purchase;
  purchaseReceipt: PurchaseReceipt;
  purchaseReceipts: PurchaseReceiptsResponse;
  purchaseReimbursement: PurchaseReimbursement;
  randomBrand: Brand;
  review?: Maybe<Review>;
  reviewReply: ReviewReply;
  reviewRevision: ReviewRevision;
  reviews: Array<Review>;
  shopifyConnection?: Maybe<ShopifyConnection>;
  sitemapData: SitemapData;
  stories: StoriesResponse;
  story?: Maybe<Story>;
  storyAuthors: Array<User>;
  stripeProducts: Array<StripeProduct>;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  subscriptionPlans: Array<SubscriptionPlan>;
  tag?: Maybe<Tag>;
  user?: Maybe<User>;
  users: UsersResponse;
};


export type QueryAvailableTagsArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryBrandArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryBrandEditSuggestionArgs = {
  id: Scalars['Int'];
};


export type QueryBrandEditSuggestionsArgs = {
  brandId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<BrandEditSuggestionStatus>;
};


export type QueryBrandReviewReactionsArgs = {
  brandId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryBrandRevisionsArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  includeAdminRevisions?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandsArgs = {
  brandIds?: InputMaybe<Array<Scalars['Int']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Scalars['String']>;
  demographics?: InputMaybe<Array<Scalars['String']>>;
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  filters?: InputMaybe<Array<Scalars['String']>>;
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
  includePromotions?: InputMaybe<Scalars['Boolean']>;
  internalTags?: InputMaybe<Array<Scalars['String']>>;
  order?: InputMaybe<BrandSortOrder>;
  searchQuery?: InputMaybe<Scalars['String']>;
  shippingDestinations?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<BrandFilterStatus>;
  take?: InputMaybe<Scalars['Int']>;
  verificationStatus?: InputMaybe<BrandVerificationStatusFilter>;
};


export type QueryCartArgs = {
  id: Scalars['ID'];
};


export type QueryCartShippingMethodsArgs = {
  id: Scalars['ID'];
};


export type QueryCategoriesArgs = {
  onlyRoots?: InputMaybe<Scalars['Boolean']>;
  parentIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryCategoryArgs = {
  slug: Scalars['String'];
};


export type QueryCheckExternalLinkDataArgs = {
  id: Scalars['String'];
};


export type QueryContributorApplicationArgs = {
  belongsToMe?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryContributorApplicationsArgs = {
  brandId?: InputMaybe<Scalars['Int']>;
  showAll?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ContributorApplicationStatus>;
};


export type QueryContributorLeadsArgs = {
  brandId?: InputMaybe<Scalars['Int']>;
};


export type QueryContributorsArgs = {
  brandId?: InputMaybe<Scalars['Int']>;
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryEditReviewArgs = {
  id: Scalars['ID'];
};


export type QueryEligibileToContributeToBrandArgs = {
  brandId: Scalars['Int'];
};


export type QueryFindBrandRedirectArgs = {
  slug: Scalars['String'];
};


export type QueryListArgs = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ListType>;
  username?: InputMaybe<Scalars['String']>;
};


export type QueryListsArgs = {
  allPublicUserCreated?: InputMaybe<Scalars['Boolean']>;
  listIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryMediaUploadArgs = {
  id: Scalars['ID'];
};


export type QueryMerchantArgs = {
  brandId: Scalars['ID'];
};


export type QueryMerchantProductsArgs = {
  brandId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryMyBrandOwnershipArgs = {
  brandId: Scalars['ID'];
};


export type QueryPopularBrandsArgs = {
  limit?: Scalars['Int'];
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductDropArgs = {
  id: Scalars['ID'];
};


export type QueryProductDropsArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<ProductDropFilter>;
  isPromoted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductDropSortOrder>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryProductOfferCampaignArgs = {
  id: Scalars['ID'];
};


export type QueryProductOfferCampaignsArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  isPromoted?: InputMaybe<Scalars['Boolean']>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPurchaseArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseReceiptArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseReceiptsArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<PurchaseReceiptStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPurchaseReimbursementArgs = {
  id: Scalars['ID'];
};


export type QueryReviewArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryReviewReplyArgs = {
  id: Scalars['ID'];
};


export type QueryReviewRevisionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryReviewsArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  brandStatus?: InputMaybe<BrandFilterStatus>;
  filter?: InputMaybe<Scalars['String']>;
  minimumAuthorLevel?: InputMaybe<Scalars['Int']>;
  minimumScore?: InputMaybe<Scalars['Int']>;
  skipCache?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ReviewFilterStatus>;
  take?: Scalars['Int'];
  withBody?: InputMaybe<Scalars['Boolean']>;
  withMedia?: InputMaybe<Scalars['Boolean']>;
};


export type QueryShopifyConnectionArgs = {
  storeId?: InputMaybe<Scalars['ID']>;
  storeUrl?: InputMaybe<Scalars['String']>;
};


export type QuerySitemapDataArgs = {
  accessToken: Scalars['String'];
};


export type QueryStoriesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  skip?: InputMaybe<Scalars['Int']>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryStoryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  latestSpotted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionPlanArgs = {
  name: Scalars['String'];
};


export type QueryTagArgs = {
  id: Scalars['Int'];
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  orderBy?: InputMaybe<UserOrderBy>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type RawProduct = {
  __typename?: 'RawProduct';
  currency: Scalars['String'];
  defaultImageUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  maxPrice: Scalars['Int'];
  minPrice: Scalars['Int'];
  name: Scalars['String'];
  offerId: Scalars['ID'];
  skus: Array<RawSku>;
  variantsMap: Array<ProductVariantMap>;
};

export type RawSku = {
  __typename?: 'RawSku';
  id: Scalars['ID'];
  name: Scalars['String'];
  qty_available: Scalars['Int'];
  retail_price: Scalars['Int'];
  sale_price: Scalars['Int'];
};

export type ReactionResponse = {
  __typename?: 'ReactionResponse';
  result: AddOrRemoveResult;
  reviewId: Scalars['ID'];
};

export enum ReactionType {
  Clap = 'Clap'
}

export type ReceiptProductLineItem = {
  __typename?: 'ReceiptProductLineItem';
  confidenceLevel: Scalars['Float'];
  text: Scalars['String'];
  totalPrice: Scalars['Float'];
  unitPrice: Scalars['Float'];
};

export type RelatedBrandsResponse = {
  __typename?: 'RelatedBrandsResponse';
  category?: Maybe<Category>;
  hasMore: Scalars['Boolean'];
  items: Array<Brand>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ReplyType {
  Learn = 'Learn',
  Love = 'Love',
  Reply = 'Reply',
  Thank = 'Thank'
}

export type ReportResponse = {
  __typename?: 'ReportResponse';
  reportId: Scalars['ID'];
  result: AddOrRemoveResult;
};

export enum ReportType {
  Automated = 'Automated',
  User = 'User'
}

export type Review = {
  __typename?: 'Review';
  affiliation?: Maybe<Scalars['String']>;
  author: User;
  authorId: Scalars['ID'];
  bodyNegative: Scalars['String'];
  bodyPositive: Scalars['String'];
  bodyPrivate: Scalars['String'];
  brand: Brand;
  brandId: Scalars['ID'];
  brandProductIds: Array<Scalars['Int']>;
  brandProducts: Array<BrandProduct>;
  clapCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  images: Array<MediaUpload>;
  isEditable: Scalars['Boolean'];
  linkedStory?: Maybe<Story>;
  media: Array<MediaUpload>;
  mediaUploadIds: Array<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  reactions: Array<ReviewReaction>;
  readsCount: Scalars['Int'];
  replies: Array<ReviewReply>;
  replyCount: Scalars['Int'];
  reports: Array<ReviewReport>;
  revisions: Array<ReviewRevision>;
  stars?: Maybe<Scalars['Int']>;
  tagIds: Array<Scalars['ID']>;
  tags: Array<Tag>;
  updatedAt: Scalars['DateTime'];
  videos: Array<MediaUpload>;
  wouldRecommend?: Maybe<Scalars['Boolean']>;
};


export type ReviewRevisionsArgs = {
  take?: InputMaybe<Scalars['Int']>;
};

export type ReviewAiSummary = {
  __typename?: 'ReviewAiSummary';
  strengths: Array<Scalars['String']>;
  summary: Scalars['String'];
  weaknesses: Array<Scalars['String']>;
};

export enum ReviewFilterStatus {
  Deleted = 'Deleted',
  Published = 'Published',
  Reported = 'Reported'
}

export type ReviewInput = {
  affiliation?: InputMaybe<Scalars['String']>;
  bodyNegative?: InputMaybe<Scalars['String']>;
  bodyPositive?: InputMaybe<Scalars['String']>;
  bodyPrivate?: InputMaybe<Scalars['String']>;
  brandProductIds?: InputMaybe<Array<Scalars['Int']>>;
  brandProducts?: InputMaybe<Array<BrandProductInput>>;
  mediaUploadIds?: InputMaybe<Array<Scalars['Int']>>;
  stars?: InputMaybe<Scalars['Int']>;
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
  wouldRecommend?: InputMaybe<Scalars['Boolean']>;
};

export type ReviewReaction = {
  __typename?: 'ReviewReaction';
  anonymousId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  reviewId: Scalars['ID'];
  type: ReactionType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export type ReviewReply = {
  __typename?: 'ReviewReply';
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  reviewId: Scalars['ID'];
  type: ReplyType;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['ID'];
};

export type ReviewReport = {
  __typename?: 'ReviewReport';
  acknowledgedAt?: Maybe<Scalars['String']>;
  acknowledgedByUser?: Maybe<User>;
  author?: Maybe<User>;
  authorId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  reason: Scalars['String'];
  reviewId: Scalars['ID'];
  type: ReportType;
  updatedAt: Scalars['DateTime'];
};

export type ReviewRevision = {
  __typename?: 'ReviewRevision';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  review: Review;
  snapshot: Scalars['JSON'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export enum ReviewSortOrder {
  Latest = 'Latest',
  Oldest = 'Oldest',
  Popular = 'Popular',
  Recommended = 'Recommended'
}

export type ReviewSummary = {
  __typename?: 'ReviewSummary';
  averageRating?: Maybe<Scalars['Float']>;
  brandId: Scalars['ID'];
  popularTags?: Maybe<Array<Tag>>;
  ratingDistribution?: Maybe<Scalars['JSON']>;
  ratingsCount: Scalars['Float'];
  wouldRecommendPercent?: Maybe<Scalars['Float']>;
};

export type ReviewsResponse = {
  __typename?: 'ReviewsResponse';
  hasMore: Scalars['Boolean'];
  items: Array<Review>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ShippingCountry = {
  __typename?: 'ShippingCountry';
  code: Scalars['String'];
  name: Scalars['String'];
  states?: Maybe<Array<ShippingState>>;
};

export type ShippingCountryInput = {
  code: Scalars['String'];
  name: Scalars['String'];
  states?: InputMaybe<Array<ShippingStateInput>>;
};

export type ShippingMethodInput = {
  bag_id: Scalars['Int'];
  shipping_method_id: Scalars['String'];
};

export type ShippingReadinessCheck = {
  __typename?: 'ShippingReadinessCheck';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  result?: Maybe<BagShippingMethods>;
  status: ShippingReadinessCheckStatus;
};

export enum ShippingReadinessCheckStatus {
  Failed = 'Failed',
  Passed = 'Passed'
}

export type ShippingState = {
  __typename?: 'ShippingState';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type ShippingStateInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type ShopifyConnection = {
  __typename?: 'ShopifyConnection';
  brand: Brand;
  clientId: Scalars['String'];
  connectionNonce: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isConnected: Scalars['Boolean'];
  shopifyThemeIsSupported: Scalars['Boolean'];
  storeId?: Maybe<Scalars['Float']>;
  storeUrl: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ShopifyConnectionInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  storeUrl: Scalars['String'];
};

export type ShopifyFinalizeConnectionInput = {
  brandId: Scalars['ID'];
  code: Scalars['String'];
  hmac: Scalars['String'];
  host: Scalars['String'];
  shop: Scalars['String'];
  state: Scalars['String'];
  timestamp: Scalars['String'];
};

export type SitemapData = {
  __typename?: 'SitemapData';
  brands: Array<Brand>;
  categories: Array<Category>;
  stories: Array<Story>;
};

export type StoriesResponse = {
  __typename?: 'StoriesResponse';
  hasMore: Scalars['Boolean'];
  items: Array<Story>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export type Story = {
  __typename?: 'Story';
  author: User;
  authorId?: Maybe<Scalars['Float']>;
  categories: Array<Category>;
  categoryIds: Array<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  document?: Maybe<Scalars['JSON']>;
  entityRelations?: Maybe<StoryEntityRelations>;
  id: Scalars['ID'];
  imageFullPath?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  /** @deprecated Use imageFullPath instead */
  metaImageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  status: StoryStatus;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type StoryEntityRelations = {
  __typename?: 'StoryEntityRelations';
  brandIds?: Maybe<Array<Scalars['String']>>;
};

export type StoryInput = {
  authorId?: InputMaybe<Scalars['Int']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  document?: InputMaybe<Scalars['JSON']>;
  imageFullPath?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StoryStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export enum StoryStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  stripeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  amount_due: Scalars['Int'];
  amount_paid: Scalars['Int'];
  created: Scalars['Float'];
  currency: Scalars['String'];
  hosted_invoice_url: Scalars['String'];
  id: Scalars['ID'];
  invoice_pdf: Scalars['String'];
  number: Scalars['String'];
  period_end: Scalars['Int'];
  period_start: Scalars['Int'];
  status: Scalars['String'];
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  cardBrand?: Maybe<Scalars['String']>;
  cardLastDigits?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type StripePrice = {
  __typename?: 'StripePrice';
  currency: Scalars['String'];
  id: Scalars['ID'];
  recurring?: Maybe<StripeRecurringPrice>;
  type: Scalars['String'];
  unit_amount?: Maybe<Scalars['Int']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StripeRecurringPrice = {
  __typename?: 'StripeRecurringPrice';
  interval: Scalars['String'];
  interval_count: Scalars['Int'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  currency: Scalars['String'];
  id: Scalars['ID'];
  paymentMethod?: Maybe<StripePaymentMethod>;
  price: StripePrice;
};

export enum SubscriptionFeature {
  BrandSubscriptions = 'BrandSubscriptions',
  BrandUserInvite = 'BrandUserInvite',
  MiniDrop = 'MiniDrop',
  MultipleImages = 'MultipleImages',
  PrivateFeedback = 'PrivateFeedback',
  PromotedDrop = 'PromotedDrop',
  ReplyToReviews = 'ReplyToReviews',
  ShopifyReviews = 'ShopifyReviews'
}

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  features: Array<SubscriptionFeature>;
  id: Scalars['ID'];
  isAutoApplied: Scalars['Boolean'];
  isAvailable: Scalars['Boolean'];
  name: Scalars['String'];
  priceMonthly?: Maybe<StripePrice>;
  priceYearly?: Maybe<StripePrice>;
  updatedAt: Scalars['DateTime'];
};

export type SubscriptionResponse = {
  __typename?: 'SubscriptionResponse';
  newsletter?: Maybe<Scalars['String']>;
  notifications?: Maybe<Scalars['String']>;
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  payload?: Maybe<Scalars['JSON']>;
  success: Scalars['Boolean'];
};

export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UpdatePurchaseReceiptInput = {
  reimbursableValue?: InputMaybe<Scalars['Int']>;
  status: PurchaseReceiptStatus;
  totalValue?: InputMaybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  abilities: Scalars['JSON'];
  achievements?: Maybe<Array<Achievement>>;
  /** @deprecated User avatarFullPath instead */
  avatarFilename?: Maybe<Scalars['String']>;
  avatarFullPath?: Maybe<Scalars['String']>;
  avatarImageUrl?: Maybe<Scalars['String']>;
  betaTester: Scalars['Boolean'];
  bio?: Maybe<Scalars['String']>;
  brandReviewReactions: Array<ReviewReaction>;
  carts: Array<Cart>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firebaseUid: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  firstReviewOfBrandCount: Scalars['Int'];
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  hasAddedAdditionalInformation: Scalars['Boolean'];
  hasCompletedProfile: Scalars['Boolean'];
  id: Scalars['ID'];
  interests: UserInterests;
  /** @deprecated Deprecated in favor of karma and levels */
  isSupertester: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  karma: Scalars['Int'];
  karmaRequirementForNextLevel?: Maybe<Scalars['Int']>;
  karmaRequirementForPreviousLevel?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  latestKarmaEvents?: Maybe<Array<UserKarma>>;
  level: Scalars['Int'];
  listCount: Scalars['Int'];
  lists: Array<List>;
  location?: Maybe<Scalars['String']>;
  membershipExpiresAt?: Maybe<Scalars['DateTime']>;
  membershipIsForever?: Maybe<Scalars['Boolean']>;
  membershipLevel: MembershipLevel;
  milestones?: Maybe<Array<Milestone>>;
  personal: UserPersonalInfo;
  phoneNumber?: Maybe<Scalars['String']>;
  purchases: Array<Purchase>;
  reviewCount: Scalars['Int'];
  reviewMediaCount: Scalars['Int'];
  reviews: ReviewsResponse;
  role: UserRole;
  socialAccounts: UserSocialAccounts;
  specialLists: Scalars['JSON'];
  storyAuthor?: Maybe<Scalars['Boolean']>;
  subscriptions: SubscriptionResponse;
  summary: UserSummary;
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
  verificationStatus: VerificationStatus;
  verifiedAt?: Maybe<Scalars['DateTime']>;
  yearOfBirth?: Maybe<Scalars['Int']>;
};


export type UserBrandReviewReactionsArgs = {
  brandId: Scalars['ID'];
};


export type UserCartsArgs = {
  includeInProgress?: InputMaybe<Scalars['Boolean']>;
};


export type UserLatestKarmaEventsArgs = {
  reviewId?: InputMaybe<Scalars['Int']>;
};


export type UserPurchasesArgs = {
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type UserReviewsArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  exclude?: InputMaybe<Array<Scalars['ID']>>;
  order?: InputMaybe<UserReviewsOrder>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type UserBrandOwnership = {
  __typename?: 'UserBrandOwnership';
  cartId: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  ownershipProof: UserBrandOwnershipProof;
  updatedAt: Scalars['DateTime'];
};

export enum UserBrandOwnershipProof {
  BrandSourced = 'BrandSourced',
  Purchase = 'Purchase',
  Unknown = 'Unknown'
}

export type UserInterests = {
  __typename?: 'UserInterests';
  /** @deprecated Replaced by categoryIds */
  categories?: Maybe<Array<Scalars['String']>>;
  categoryIds?: Maybe<Array<Scalars['Int']>>;
  /** @deprecated Replaced by categoryIds */
  subcategories?: Maybe<Array<Scalars['String']>>;
};

export type UserInterestsInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  subcategories?: InputMaybe<Array<Scalars['String']>>;
};

export type UserKarma = {
  __typename?: 'UserKarma';
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  humanReadableName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  karmaEvent: Scalars['String'];
  review?: Maybe<Review>;
  reviewId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export enum UserOrderBy {
  KarmaDesc = 'Karma_Desc',
  ReviewCountAsc = 'Review_Count_Asc',
  ReviewCountDesc = 'Review_Count_Desc'
}

export type UserPersonalInfo = {
  __typename?: 'UserPersonalInfo';
  birthday?: Maybe<Scalars['StringDate']>;
  hasKids?: Maybe<Scalars['StringBool']>;
  hasPets?: Maybe<Scalars['StringBool']>;
  pronoun?: Maybe<Pronoun>;
};

export type UserPersonalInfoInput = {
  birthday?: InputMaybe<Scalars['StringDate']>;
  hasKids?: InputMaybe<Scalars['StringBool']>;
  hasPets?: InputMaybe<Scalars['StringBool']>;
  pronoun?: InputMaybe<Pronoun>;
};

export type UserPhoneVerificationInput = {
  phoneNumber: Scalars['String'];
  token: Scalars['String'];
};

export type UserProfileInput = {
  avatarFullPath?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  interests?: InputMaybe<UserInterestsInput>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
  personal?: InputMaybe<UserPersonalInfoInput>;
  socialAccounts?: InputMaybe<UserSocialAccountsInput>;
  username?: InputMaybe<Scalars['String']>;
  yearOfBirth?: InputMaybe<Scalars['Int']>;
};

export enum UserProfileInputScope {
  Default = 'Default',
  Reviews = 'Reviews'
}

export enum UserReviewsOrder {
  Latest = 'Latest',
  MediaFirst = 'MediaFirst',
  MostRead = 'MostRead'
}

export enum UserRole {
  Admin = 'Admin',
  Member = 'Member',
  None = 'None'
}

export type UserSocialAccounts = {
  __typename?: 'UserSocialAccounts';
  instagramUsername?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['Url']>;
  tiktokUsername?: Maybe<Scalars['String']>;
  twitterUsername?: Maybe<Scalars['String']>;
};

export type UserSocialAccountsInput = {
  instagramUsername?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['Url']>;
  tiktokUsername?: InputMaybe<Scalars['String']>;
  twitterUsername?: InputMaybe<Scalars['String']>;
};

export type UserSummary = {
  __typename?: 'UserSummary';
  averageRating?: Maybe<Scalars['Float']>;
  ratingDistribution?: Maybe<Scalars['JSON']>;
  totalClapsReceived: Scalars['Float'];
  totalReadsCount: Scalars['Float'];
  totalReviews: Scalars['Float'];
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  hasMore: Scalars['Boolean'];
  items: Array<User>;
  nextSkip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum VerificationStatus {
  Manual = 'Manual',
  Pending = 'Pending',
  Phone = 'Phone'
}

export type AdminBrandEditSuggestionsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['Int']>;
  status: BrandEditSuggestionStatus;
}>;


export type AdminBrandEditSuggestionsQuery = { __typename?: 'Query', brandEditSuggestions: Array<{ __typename?: 'BrandEditSuggestion', id: string, brandSnapshot?: any | null, edits?: any | null, status: BrandEditSuggestionStatus, createdAt: string, brand: { __typename?: 'Brand', id: string, title: string }, contributor?: { __typename?: 'Contributor', relationshipToBrand?: string | null } | null, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarImageUrl?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, role: UserRole } }> };

export type AdminEditSuggestionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminEditSuggestionQuery = { __typename?: 'Query', brandEditSuggestion: { __typename?: 'BrandEditSuggestion', id: string, brandSnapshot?: any | null, createdAt: string, edits?: any | null, status: BrandEditSuggestionStatus, brand: { __typename?: 'Brand', id: string, title: string }, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarImageUrl?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, role: UserRole }, contributor?: { __typename?: 'Contributor', relationshipToBrand?: string | null } | null } };

export type AdminApplyEditSuggestionMutationVariables = Exact<{
  id: Scalars['Int'];
  brandId: Scalars['Int'];
  input: BrandInput;
}>;


export type AdminApplyEditSuggestionMutation = { __typename?: 'Mutation', applyBrandEditSuggestion: { __typename?: 'BrandEditSuggestion', id: string, status: BrandEditSuggestionStatus, brand: { __typename?: 'Brand', id: string, title: string, slug: string, status: BrandStatus, rip: boolean, description?: string | null, descriptionFromBrand?: string | null, impactInitiatives?: string | null, assetsFolder: string, primaryImageCredit?: string | null, primaryImageFullPath?: string | null, primaryImageUploaderType?: PrimaryImageUploaderType | null, publishedAt?: string | null, webUrl?: string | null, alternativeWebUrls: Array<string>, keywords?: string | null, categoryIds: Array<number>, createdAt: string, updatedAt: string, shipsTo: any, instagramReviewUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string }>, discountCodes?: Array<{ __typename?: 'DiscountCode', title: string, code: string, expiryDate?: string | null, limitToSupertesters?: boolean | null }> | null, people?: { __typename?: 'BrandPeopleData', demographics?: Array<string> | null, founders?: Array<{ __typename?: 'Person', name: string }> | null } | null, company?: { __typename?: 'BrandCompanyData', certificates?: Array<string> | null, retail?: boolean | null, dateFounded?: string | null, dateLaunched?: string | null, hqLocation?: string | null, instagram?: string | null, twitter?: string | null, facebookUrl?: any | null, linkedinUrl?: any | null, tiktokUrl?: any | null, pintrestUrl?: any | null, youtubeUrl?: any | null, hqGps?: { __typename?: 'GeoCoordinate', latitude?: string | null, longitude?: string | null } | null } | null, externalLinks?: Array<{ __typename?: 'ExternalLink', imageUrl?: string | null, storageId: string, title?: string | null, url: string }> | null, addedBy: { __typename?: 'User', id: string, fullName?: string | null, username: string }, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null, secondaryImages: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, credit?: string | null, caption?: string | null }>, reviewableProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, numberOfReviews: number, slug: string }> } } };

export type AdminRejectEditSuggestionMutationVariables = Exact<{
  id: Scalars['Int'];
  brandId: Scalars['Int'];
}>;


export type AdminRejectEditSuggestionMutation = { __typename?: 'Mutation', rejectBrandEditSuggestion: { __typename?: 'BrandEditSuggestion', id: string, status: BrandEditSuggestionStatus } };

export type AdminBrandSearchFieldsFragment = { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null, internalTags: Array<string>, status: BrandStatus, createdAt: string, publishedAt?: string | null, verificationStatus: BrandVerificationStatus, webUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string }> };

export type AdminBrandSearchQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']>;
  internalTags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BrandFilterStatus>;
  verificationStatus?: InputMaybe<BrandVerificationStatusFilter>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AdminBrandSearchQuery = { __typename?: 'Query', brands: { __typename?: 'BrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null, internalTags: Array<string>, status: BrandStatus, createdAt: string, publishedAt?: string | null, verificationStatus: BrandVerificationStatus, webUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string }> }> } };

export type AdminSearchMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminSearchMetadataQuery = { __typename?: 'Query', metadataSummary: { __typename?: 'BrandMetadataSummary', internalTags: Array<string> } };

export type AdminUpdateSearchBrandsMutationVariables = Exact<{
  input: BrandInput;
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type AdminUpdateSearchBrandsMutation = { __typename?: 'Mutation', updateBrands: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null, internalTags: Array<string>, status: BrandStatus, createdAt: string, publishedAt?: string | null, verificationStatus: BrandVerificationStatus, webUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string }> }> };

export type AdminEditBrandFieldsFragment = { __typename?: 'Brand', internalTags: Array<string>, verificationStatus: BrandVerificationStatus, tags: any, lastContributionAt?: string | null };

export type AdminCreateBrandMutationVariables = Exact<{
  input: BrandInput;
  assetsFolder: Scalars['String'];
}>;


export type AdminCreateBrandMutation = { __typename?: 'Mutation', createBrand: { __typename?: 'Brand', id: string, internalTags: Array<string>, verificationStatus: BrandVerificationStatus, tags: any, lastContributionAt?: string | null, title: string, slug: string, status: BrandStatus, rip: boolean, description?: string | null, descriptionFromBrand?: string | null, impactInitiatives?: string | null, assetsFolder: string, primaryImageCredit?: string | null, primaryImageFullPath?: string | null, primaryImageUploaderType?: PrimaryImageUploaderType | null, publishedAt?: string | null, webUrl?: string | null, alternativeWebUrls: Array<string>, keywords?: string | null, categoryIds: Array<number>, createdAt: string, updatedAt: string, shipsTo: any, instagramReviewUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string }>, discountCodes?: Array<{ __typename?: 'DiscountCode', title: string, code: string, expiryDate?: string | null, limitToSupertesters?: boolean | null }> | null, people?: { __typename?: 'BrandPeopleData', demographics?: Array<string> | null, founders?: Array<{ __typename?: 'Person', name: string }> | null } | null, company?: { __typename?: 'BrandCompanyData', certificates?: Array<string> | null, retail?: boolean | null, dateFounded?: string | null, dateLaunched?: string | null, hqLocation?: string | null, instagram?: string | null, twitter?: string | null, facebookUrl?: any | null, linkedinUrl?: any | null, tiktokUrl?: any | null, pintrestUrl?: any | null, youtubeUrl?: any | null, hqGps?: { __typename?: 'GeoCoordinate', latitude?: string | null, longitude?: string | null } | null } | null, externalLinks?: Array<{ __typename?: 'ExternalLink', imageUrl?: string | null, storageId: string, title?: string | null, url: string }> | null, addedBy: { __typename?: 'User', id: string, fullName?: string | null, username: string }, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null, secondaryImages: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, credit?: string | null, caption?: string | null }>, reviewableProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, numberOfReviews: number, slug: string }> } };

export type AdminUpdateBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  input: BrandInput;
}>;


export type AdminUpdateBrandMutation = { __typename?: 'Mutation', updateBrand?: { __typename?: 'Brand', id: string, internalTags: Array<string>, verificationStatus: BrandVerificationStatus, tags: any, lastContributionAt?: string | null, title: string, slug: string, status: BrandStatus, rip: boolean, description?: string | null, descriptionFromBrand?: string | null, impactInitiatives?: string | null, assetsFolder: string, primaryImageCredit?: string | null, primaryImageFullPath?: string | null, primaryImageUploaderType?: PrimaryImageUploaderType | null, publishedAt?: string | null, webUrl?: string | null, alternativeWebUrls: Array<string>, keywords?: string | null, categoryIds: Array<number>, createdAt: string, updatedAt: string, shipsTo: any, instagramReviewUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string }>, discountCodes?: Array<{ __typename?: 'DiscountCode', title: string, code: string, expiryDate?: string | null, limitToSupertesters?: boolean | null }> | null, people?: { __typename?: 'BrandPeopleData', demographics?: Array<string> | null, founders?: Array<{ __typename?: 'Person', name: string }> | null } | null, company?: { __typename?: 'BrandCompanyData', certificates?: Array<string> | null, retail?: boolean | null, dateFounded?: string | null, dateLaunched?: string | null, hqLocation?: string | null, instagram?: string | null, twitter?: string | null, facebookUrl?: any | null, linkedinUrl?: any | null, tiktokUrl?: any | null, pintrestUrl?: any | null, youtubeUrl?: any | null, hqGps?: { __typename?: 'GeoCoordinate', latitude?: string | null, longitude?: string | null } | null } | null, externalLinks?: Array<{ __typename?: 'ExternalLink', imageUrl?: string | null, storageId: string, title?: string | null, url: string }> | null, addedBy: { __typename?: 'User', id: string, fullName?: string | null, username: string }, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null, secondaryImages: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, credit?: string | null, caption?: string | null }>, reviewableProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, numberOfReviews: number, slug: string }> } | null };

export type AdminGetFullBrandQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminGetFullBrandQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, internalTags: Array<string>, verificationStatus: BrandVerificationStatus, tags: any, lastContributionAt?: string | null, title: string, slug: string, status: BrandStatus, rip: boolean, description?: string | null, descriptionFromBrand?: string | null, impactInitiatives?: string | null, assetsFolder: string, primaryImageCredit?: string | null, primaryImageFullPath?: string | null, primaryImageUploaderType?: PrimaryImageUploaderType | null, publishedAt?: string | null, webUrl?: string | null, alternativeWebUrls: Array<string>, keywords?: string | null, categoryIds: Array<number>, createdAt: string, updatedAt: string, shipsTo: any, instagramReviewUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string }>, discountCodes?: Array<{ __typename?: 'DiscountCode', title: string, code: string, expiryDate?: string | null, limitToSupertesters?: boolean | null }> | null, people?: { __typename?: 'BrandPeopleData', demographics?: Array<string> | null, founders?: Array<{ __typename?: 'Person', name: string }> | null } | null, company?: { __typename?: 'BrandCompanyData', certificates?: Array<string> | null, retail?: boolean | null, dateFounded?: string | null, dateLaunched?: string | null, hqLocation?: string | null, instagram?: string | null, twitter?: string | null, facebookUrl?: any | null, linkedinUrl?: any | null, tiktokUrl?: any | null, pintrestUrl?: any | null, youtubeUrl?: any | null, hqGps?: { __typename?: 'GeoCoordinate', latitude?: string | null, longitude?: string | null } | null } | null, externalLinks?: Array<{ __typename?: 'ExternalLink', imageUrl?: string | null, storageId: string, title?: string | null, url: string }> | null, addedBy: { __typename?: 'User', id: string, fullName?: string | null, username: string }, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null, secondaryImages: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, credit?: string | null, caption?: string | null }>, reviewableProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, numberOfReviews: number, slug: string }> } | null };

export type AdminGetBrandRevisionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminGetBrandRevisionsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, title: string, revisions: Array<{ __typename?: 'BrandRevision', id: string, createdAt: string, delta: any, snapshot: any, edits: any, user: { __typename?: 'User', id: string, email: string, fullName?: string | null, username: string, avatarImageUrl?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, role: UserRole }, authorizedByUser?: { __typename?: 'User', id: string, email: string, fullName?: string | null, username: string, avatarImageUrl?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, role: UserRole } | null }> } | null };

export type AdminGetBrandMetadataSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetBrandMetadataSuggestionsQuery = { __typename?: 'Query', metadataSummary: { __typename?: 'BrandMetadataSummary', demographics: Array<string>, rooms: Array<string>, tags: Array<string>, founderDemographics: Array<string>, companyCertificates: Array<string> } };

export type AdminBrandsPipelineQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  status: BrandFilterStatus;
  internalTags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AdminBrandsPipelineQuery = { __typename?: 'Query', brands: { __typename?: 'BrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, status: BrandStatus, primaryImageFullPath?: string | null, description?: string | null, descriptionFromBrand?: string | null, internalTags: Array<string>, assetsFolder: string, categoryIds: Array<number>, webUrl?: string | null, company?: { __typename?: 'BrandCompanyData', instagram?: string | null } | null, addedBy: { __typename?: 'User', id: string, fullName?: string | null, avatarFullPath?: string | null, username: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }> }> } };

export type BrandRevisionFieldsFragment = { __typename?: 'BrandRevision', id: string, delta: any, snapshot: any, createdAt: string, brand: { __typename?: 'Brand', id: string, title: string, primaryImageFullPath?: string | null }, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarFullPath?: string | null } };

export type AdminBrandRevisionsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AdminBrandRevisionsQuery = { __typename?: 'Query', brandRevisions: { __typename?: 'BrandRevisionsResponse', hasMore: boolean, total: number, nextSkip: number, items: Array<{ __typename?: 'BrandRevision', id: string, delta: any, snapshot: any, createdAt: string, brand: { __typename?: 'Brand', id: string, title: string, primaryImageFullPath?: string | null }, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarFullPath?: string | null } }> } };

export type ContributorLeadsBrandQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContributorLeadsBrandQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, webUrlDomain?: string | null } | null };

export type AdminMostRecentSortOrderWeightQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type AdminMostRecentSortOrderWeightQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, mostRecentSortOrderWeight?: { __typename?: 'BrandSortOrderWeightHistory', id: string, brandsCount: number, position: number, createdAt: string, weight: number, weightBreakdown: any } | null } | null };

export type AdminSortOrderWeightHistoryQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type AdminSortOrderWeightHistoryQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, sortOrderWeightHistory: Array<{ __typename?: 'BrandSortOrderWeightHistory', id: string, createdAt: string, weight: number, position: number, weightBreakdown: any }> } | null };

export type BrandContributorLeadsQueryVariables = Exact<{
  brandId: Scalars['Int'];
}>;


export type BrandContributorLeadsQuery = { __typename?: 'Query', contributorLeads: Array<{ __typename?: 'ContributorLead', id: string, email: string, createdAt: string, addedByUser: { __typename?: 'User', id: string, fullName?: string | null } }> };

export type CreateContributorLeadMutationVariables = Exact<{
  input: ContributorLeadInput;
}>;


export type CreateContributorLeadMutation = { __typename?: 'Mutation', createContributorLead: { __typename?: 'ContributorLead', id: string, email: string, createdAt: string, brandId: number, addedByUser: { __typename?: 'User', id: string, fullName?: string | null } } };

export type RemoveContributorLeadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveContributorLeadMutation = { __typename?: 'Mutation', removeContributorLead: { __typename?: 'SuccessResponse', success: boolean } };

export type AdminContributorApplicationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminContributorApplicationQuery = { __typename?: 'Query', contributorApplication?: { __typename?: 'ContributorApplication', id: string, approvalToken?: string | null, status: ContributorApplicationStatus, createdAt: string, message?: string | null, relationshipToBrand: string, linkedInUrl?: string | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null, description?: string | null, contributors: Array<{ __typename?: 'Contributor', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarImageUrl?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, role: UserRole } }> }, user: { __typename?: 'User', id: string, fullName?: string | null, avatarImageUrl?: string | null, createdAt: string, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, role: UserRole, email: string } } | null };

export type AdminChangeContributorApplicationStatusMutationVariables = Exact<{
  id: Scalars['Int'];
  status: ContributorApplicationStatus;
}>;


export type AdminChangeContributorApplicationStatusMutation = { __typename?: 'Mutation', changeContributorApplicationStatus: { __typename?: 'ContributorApplication', id: string, status: ContributorApplicationStatus } };

export type AdminContributorApplicationsQueryVariables = Exact<{
  status?: InputMaybe<ContributorApplicationStatus>;
  brandId?: InputMaybe<Scalars['Int']>;
}>;


export type AdminContributorApplicationsQuery = { __typename?: 'Query', contributorApplications: Array<{ __typename?: 'ContributorApplication', id: string, status: ContributorApplicationStatus, createdAt: string, message?: string | null, relationshipToBrand: string, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null }, user: { __typename?: 'User', id: string, fullName?: string | null, avatarImageUrl?: string | null, role: UserRole, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus } }> };

export type AdminContributorsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['Int']>;
}>;


export type AdminContributorsQuery = { __typename?: 'Query', contributors: { __typename?: 'ContributorsResponse', items: Array<{ __typename?: 'Contributor', id: string, relationshipToBrand?: string | null, createdAt: string, user: { __typename?: 'User', id: string, avatarImageUrl?: string | null, fullName?: string | null, role: UserRole, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, email: string } }> } };

export type RemoveContributorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveContributorMutation = { __typename?: 'Mutation', removeContributor: { __typename?: 'SuccessResponse', success: boolean } };

export type AdminPublicListsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminPublicListsQuery = { __typename?: 'Query', lists: Array<{ __typename?: 'List', id: string, title: string, type: ListType, isFeatured: boolean, user: { __typename?: 'User', id: string, username: string, fullName?: string | null } }> };

export type AdminToggleListFeaturedMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminToggleListFeaturedMutation = { __typename?: 'Mutation', toggleListFeatured: { __typename?: 'List', id: string, title: string, type: ListType, isFeatured: boolean, user: { __typename?: 'User', id: string, username: string, fullName?: string | null } } };

export type PendingPurchaseReceiptsQueryVariables = Exact<{
  status?: InputMaybe<PurchaseReceiptStatus>;
}>;


export type PendingPurchaseReceiptsQuery = { __typename?: 'Query', purchaseReceipts: { __typename?: 'PurchaseReceiptsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus, reimbursableValue?: number | null, totalValue?: number | null, currency: string, createdAt: string, receiptsWithSameImages: Array<{ __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus }>, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarFullPath?: string | null, reviewCount: number, level: number }, mediaUploads: Array<{ __typename?: 'MediaUpload', id: string, filePath: string }>, purchase: { __typename?: 'Purchase', id: string, createdAt: string, product: { __typename?: 'Product', id: string, name: string, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null } } } }> } };

export type PurchaseReceiptFieldsFragment = { __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus, reimbursableValue?: number | null, totalValue?: number | null, currency: string, createdAt: string, receiptsWithSameImages: Array<{ __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus }>, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarFullPath?: string | null, reviewCount: number, level: number }, mediaUploads: Array<{ __typename?: 'MediaUpload', id: string, filePath: string }>, purchase: { __typename?: 'Purchase', id: string, createdAt: string, product: { __typename?: 'Product', id: string, name: string, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null } } } };

export type AdminPurchaseReceiptQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminPurchaseReceiptQuery = { __typename?: 'Query', purchaseReceipt: { __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus, reimbursableValue?: number | null, totalValue?: number | null, currency: string, createdAt: string, receiptsWithSameImages: Array<{ __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus }>, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarFullPath?: string | null, reviewCount: number, level: number }, mediaUploads: Array<{ __typename?: 'MediaUpload', id: string, filePath: string }>, purchase: { __typename?: 'Purchase', id: string, createdAt: string, product: { __typename?: 'Product', id: string, name: string, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null } } } } };

export type UpdatePurchaseReceiptMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdatePurchaseReceiptInput;
}>;


export type UpdatePurchaseReceiptMutation = { __typename?: 'Mutation', updatePurchaseReceipt: { __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus, reimbursableValue?: number | null, totalValue?: number | null, currency: string, createdAt: string, receiptsWithSameImages: Array<{ __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus }>, user: { __typename?: 'User', id: string, fullName?: string | null, username: string, avatarFullPath?: string | null, reviewCount: number, level: number }, mediaUploads: Array<{ __typename?: 'MediaUpload', id: string, filePath: string }>, purchase: { __typename?: 'Purchase', id: string, createdAt: string, product: { __typename?: 'Product', id: string, name: string, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null } } } } };

export type AdminAcknowledgeReportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminAcknowledgeReportMutation = { __typename?: 'Mutation', toggleAcknowledgeReviewReport: { __typename?: 'ReportResponse', reportId: string, result: AddOrRemoveResult } };

export type AdminAcknowledgeAllReportsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminAcknowledgeAllReportsMutation = { __typename?: 'Mutation', acknowledgeAllReviewReports: Array<{ __typename?: 'ReviewReport', id: string, reason: string, acknowledgedAt?: string | null, createdAt: string, type: ReportType, reviewId: string, acknowledgedByUser?: { __typename?: 'User', id: string, fullName?: string | null } | null }> };

export type AdminDeleteSearchReviewsMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type AdminDeleteSearchReviewsMutation = { __typename?: 'Mutation', deleteReviews: Array<{ __typename?: 'Review', id: string, createdAt: string, publishedAt?: string | null, deletedAt?: string | null }> };

export type AdminRestoreSearchReviewsMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type AdminRestoreSearchReviewsMutation = { __typename?: 'Mutation', restoreReviews: Array<{ __typename?: 'Review', id: string, createdAt: string, publishedAt?: string | null, deletedAt?: string | null }> };

export type AdminReviewSearchFieldsFragment = { __typename?: 'Review', id: string, createdAt: string, publishedAt?: string | null, deletedAt?: string | null };

export type ReportFieldsFragment = { __typename?: 'ReviewReport', id: string, reason: string, acknowledgedAt?: string | null, createdAt: string, type: ReportType, reviewId: string, acknowledgedByUser?: { __typename?: 'User', id: string, fullName?: string | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null, username: string, email: string, createdAt: string, reviewCount: number, avatarFullPath?: string | null, verificationStatus: VerificationStatus, role: UserRole } | null };

export type AdminReviewSearchQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ReviewFilterStatus>;
}>;


export type AdminReviewSearchQuery = { __typename?: 'Query', reviews: Array<{ __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, reports: Array<{ __typename?: 'ReviewReport', id: string, reason: string, acknowledgedAt?: string | null, createdAt: string, type: ReportType, reviewId: string, acknowledgedByUser?: { __typename?: 'User', id: string, fullName?: string | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null, username: string, email: string, createdAt: string, reviewCount: number, avatarFullPath?: string | null, verificationStatus: VerificationStatus, role: UserRole } | null }>, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> }> };

export type ReviewRevisionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReviewRevisionQuery = { __typename?: 'Query', reviewRevision: { __typename?: 'ReviewRevision', id: string, review: { __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> } } };

export type LatestReviewRevisionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LatestReviewRevisionQuery = { __typename?: 'Query', review?: { __typename?: 'Review', id: string, revisions: Array<{ __typename?: 'ReviewRevision', id: string }> } | null };

export type AdminCreateStoryMutationVariables = Exact<{ [key: string]: never; }>;


export type AdminCreateStoryMutation = { __typename?: 'Mutation', createStory: { __typename?: 'Story', id: string, slug?: string | null, title?: string | null, document?: any | null, imageFullPath?: string | null, metaDescription?: string | null, publishedAt?: string | null, status: StoryStatus, authorId?: number | null, categoryIds: Array<string>, createdAt: string, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } };

export type StoriesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type StoriesQuery = { __typename?: 'Query', stories: { __typename?: 'StoriesResponse', hasMore: boolean, total: number, nextSkip: number, items: Array<{ __typename?: 'Story', createdAt: string, status: StoryStatus, id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } }> } };

export type AdminStoryFieldsFragment = { __typename?: 'Story', id: string, slug?: string | null, title?: string | null, document?: any | null, imageFullPath?: string | null, metaDescription?: string | null, publishedAt?: string | null, status: StoryStatus, authorId?: number | null, categoryIds: Array<string>, createdAt: string, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } };

export type AdminUpdateStoryMutationVariables = Exact<{
  id: Scalars['Int'];
  input: StoryInput;
}>;


export type AdminUpdateStoryMutation = { __typename?: 'Mutation', updateStory: { __typename?: 'Story', id: string, slug?: string | null, title?: string | null, document?: any | null, imageFullPath?: string | null, metaDescription?: string | null, publishedAt?: string | null, status: StoryStatus, authorId?: number | null, categoryIds: Array<string>, createdAt: string, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } };

export type AdminGetStoryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type AdminGetStoryQuery = { __typename?: 'Query', story?: { __typename?: 'Story', id: string, slug?: string | null, title?: string | null, document?: any | null, imageFullPath?: string | null, metaDescription?: string | null, publishedAt?: string | null, status: StoryStatus, authorId?: number | null, categoryIds: Array<string>, createdAt: string, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null };

export type StoryAuthorsQueryVariables = Exact<{ [key: string]: never; }>;


export type StoryAuthorsQuery = { __typename?: 'Query', storyAuthors: Array<{ __typename?: 'User', id: string, fullName?: string | null }> };

export type AllSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSubscriptionPlansQuery = { __typename?: 'Query', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, isAutoApplied: boolean, displayName?: string | null, name: string, priceMonthly?: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } | null, priceYearly?: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } | null }> };

export type AdminBrandSubscriptionsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type AdminBrandSubscriptionsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, title: string, subscriptions: Array<{ __typename?: 'BrandSubscription', id: string, stripeSubscription?: { __typename?: 'StripeSubscription', id: string, price: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } } | null, subscriptionPlan: { __typename?: 'SubscriptionPlan', id: string, name: string, displayName?: string | null, features: Array<SubscriptionFeature>, isAutoApplied: boolean } }> } | null };

export type StripeAddonProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeAddonProductsQuery = { __typename?: 'Query', stripeProducts: Array<{ __typename?: 'StripeProduct', id: string, name: string }> };

export type AdminProductDropSearchQueryVariables = Exact<{
  isPromoted?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<ProductDropSortOrder>;
}>;


export type AdminProductDropSearchQuery = { __typename?: 'Query', productDrops: Array<{ __typename?: 'ProductDrop', id: string, createdAt: string, dropsAt?: string | null, isSoldOut: boolean, isPromoted: boolean, isVisible: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, product?: { __typename?: 'Product', id: string, quantitySold?: number | null, maximumQuantitySellable?: number | null, name: string, description: string, defaultImageUrl?: string | null, variants: Array<{ __typename?: 'ProductVariant', id: string, retailPrice: number, salePrice: number, name: string, limitToSupertesters: boolean }> } | null }> };

export type AdminCreateProductDropMutationVariables = Exact<{
  brandId: Scalars['ID'];
  input: ProductDropInput;
}>;


export type AdminCreateProductDropMutation = { __typename?: 'Mutation', createProductDrop: { __typename?: 'ProductDrop', id: string, dropsAt?: string | null, brandId: number } };

export type AdminInviteBetaTesterMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type AdminInviteBetaTesterMutation = { __typename?: 'Mutation', createBetaTesterInvite: { __typename?: 'BetaTesterInviteResponse', user?: { __typename?: 'User', id: string } | null, betaTesterInvite?: { __typename?: 'BetaTesterInvite', id: string } | null } };

export type AdminCreateSessionTokenMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type AdminCreateSessionTokenMutation = { __typename?: 'Mutation', createSessionToken: { __typename?: 'SuccessResponse', success: boolean, payload?: any | null } };

export type AdminRefetchCartMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminRefetchCartMutation = { __typename?: 'Mutation', refetchCart: { __typename?: 'Cart', id: string, status: string, createdAt: string, updatedAt: string, violetCartId?: string | null, currency?: string | null, bags: Array<{ __typename?: 'CartBag', id: number, status: string, skus: Array<{ __typename?: 'CartBagSku', id: string, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, salePrice: number, product: { __typename?: 'Product', id: string, brand: { __typename?: 'Brand', id: string, title: string, primaryImageFullPath?: string | null } } } | null }> }> } };

export type UserCartFieldsFragment = { __typename?: 'Cart', id: string, status: string, createdAt: string, updatedAt: string, violetCartId?: string | null, currency?: string | null, bags: Array<{ __typename?: 'CartBag', id: number, status: string, skus: Array<{ __typename?: 'CartBagSku', id: string, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, salePrice: number, product: { __typename?: 'Product', id: string, brand: { __typename?: 'Brand', id: string, title: string, primaryImageFullPath?: string | null } } } | null }> }> };

export type AdminUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type AdminUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, fullName?: string | null, email: string, carts: Array<{ __typename?: 'Cart', id: string, status: string, createdAt: string, updatedAt: string, violetCartId?: string | null, currency?: string | null, bags: Array<{ __typename?: 'CartBag', id: number, status: string, skus: Array<{ __typename?: 'CartBagSku', id: string, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, salePrice: number, product: { __typename?: 'Product', id: string, brand: { __typename?: 'Brand', id: string, title: string, primaryImageFullPath?: string | null } } } | null }> }> }> } | null };

export type CreateCookieTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCookieTokenMutation = { __typename?: 'Mutation', createCookieToken: { __typename?: 'SuccessResponse', payload?: any | null } };

export type MyContributionsForBrandQueryVariables = Exact<{
  brandId: Scalars['Int'];
}>;


export type MyContributionsForBrandQuery = { __typename?: 'Query', brandEditSuggestions: Array<{ __typename?: 'BrandEditSuggestion', id: string, createdAt: string, status: BrandEditSuggestionStatus, user: { __typename?: 'User', id: string, fullName?: string | null } }> };

export type BrandminUpdateBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  input: BrandInput;
}>;


export type BrandminUpdateBrandMutation = { __typename?: 'Mutation', updateBrand?: { __typename?: 'Brand', id: string, title: string, slug: string, status: BrandStatus, rip: boolean, description?: string | null, descriptionFromBrand?: string | null, impactInitiatives?: string | null, assetsFolder: string, primaryImageCredit?: string | null, primaryImageFullPath?: string | null, primaryImageUploaderType?: PrimaryImageUploaderType | null, publishedAt?: string | null, webUrl?: string | null, alternativeWebUrls: Array<string>, keywords?: string | null, categoryIds: Array<number>, createdAt: string, updatedAt: string, shipsTo: any, instagramReviewUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string }>, discountCodes?: Array<{ __typename?: 'DiscountCode', title: string, code: string, expiryDate?: string | null, limitToSupertesters?: boolean | null }> | null, people?: { __typename?: 'BrandPeopleData', demographics?: Array<string> | null, founders?: Array<{ __typename?: 'Person', name: string }> | null } | null, company?: { __typename?: 'BrandCompanyData', certificates?: Array<string> | null, retail?: boolean | null, dateFounded?: string | null, dateLaunched?: string | null, hqLocation?: string | null, instagram?: string | null, twitter?: string | null, facebookUrl?: any | null, linkedinUrl?: any | null, tiktokUrl?: any | null, pintrestUrl?: any | null, youtubeUrl?: any | null, hqGps?: { __typename?: 'GeoCoordinate', latitude?: string | null, longitude?: string | null } | null } | null, externalLinks?: Array<{ __typename?: 'ExternalLink', imageUrl?: string | null, storageId: string, title?: string | null, url: string }> | null, addedBy: { __typename?: 'User', id: string, fullName?: string | null, username: string }, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null, secondaryImages: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, credit?: string | null, caption?: string | null }>, reviewableProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, numberOfReviews: number, slug: string }> } | null };

export type MyContributableBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyContributableBrandsQuery = { __typename?: 'Query', myContributableBrands: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> }> };

export type CreateOrUpdateMerchantMutationVariables = Exact<{
  brandId: Scalars['ID'];
  input: MerchantInput;
}>;


export type CreateOrUpdateMerchantMutation = { __typename?: 'Mutation', createOrUpdateMerchant: { __typename?: 'Merchant', id: string, storeUrl?: string | null, supportUrl?: string | null, supportEmail?: string | null, status: MerchantConnectionStatus, externalConnectionUrl: string } };

export type BrandProductsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandProductsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, products: Array<{ __typename?: 'Product', id: string, merchantProductId?: string | null }> } | null };

export type ConnectProductMutationVariables = Exact<{
  brandId: Scalars['ID'];
  merchantOfferId?: InputMaybe<Scalars['ID']>;
  merchantProductId?: InputMaybe<Scalars['ID']>;
}>;


export type ConnectProductMutation = { __typename?: 'Mutation', connectMerchantProduct: { __typename?: 'Product', id: string, merchantOfferId?: string | null, merchantProductId?: string | null, brandId: string } };

export type NewProductFragment = { __typename?: 'Product', id: string, merchantOfferId?: string | null, merchantProductId?: string | null, brandId: string };

export type MerchantProductsQueryVariables = Exact<{
  brandId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type MerchantProductsQuery = { __typename?: 'Query', merchantProducts: { __typename?: 'MerchantProductsResponse', total: number, hasMore: boolean, page: number, perPage: number, items: Array<{ __typename?: 'RawProduct', id: string, offerId: string, name: string, description: string, defaultImageUrl?: string | null, minPrice: number, maxPrice: number, currency: string, skus: Array<{ __typename?: 'RawSku', id: string, name: string, qty_available: number, retail_price: number, sale_price: number }> }> } };

export type MerchantConnectionFieldsFragment = { __typename?: 'Merchant', id: string, storeUrl?: string | null, supportUrl?: string | null, supportEmail?: string | null, status: MerchantConnectionStatus, externalConnectionUrl: string };

export type MerchantQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type MerchantQuery = { __typename?: 'Query', merchant?: { __typename?: 'Merchant', id: string, storeUrl?: string | null, supportUrl?: string | null, supportEmail?: string | null, status: MerchantConnectionStatus, externalConnectionUrl: string } | null };

export type CreateShopifyConnectionMutationVariables = Exact<{
  input: ShopifyConnectionInput;
}>;


export type CreateShopifyConnectionMutation = { __typename?: 'Mutation', createShopifyConnection: { __typename?: 'ShopifyConnection', id: string, connectionNonce: string, clientId: string } };

export type FinalizeShopifyConnectionMutationVariables = Exact<{
  input: ShopifyFinalizeConnectionInput;
}>;


export type FinalizeShopifyConnectionMutation = { __typename?: 'Mutation', finalizeShopifyConnection: { __typename?: 'ShopifyConnection', id: string } };

export type ShopifyConnectionQueryVariables = Exact<{
  storeId?: InputMaybe<Scalars['ID']>;
  storeUrl?: InputMaybe<Scalars['String']>;
}>;


export type ShopifyConnectionQuery = { __typename?: 'Query', shopifyConnection?: { __typename?: 'ShopifyConnection', id: string, storeId?: number | null, storeUrl: string, isConnected: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string } } | null };

export type BrandShopifyConnectionsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandShopifyConnectionsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, shopifyConnection?: { __typename?: 'ShopifyConnection', id: string, isConnected: boolean, storeId?: number | null, storeUrl: string } | null } | null };

export type ShopifyConnectionWithThemeQueryVariables = Exact<{
  storeId?: InputMaybe<Scalars['ID']>;
  storeUrl?: InputMaybe<Scalars['String']>;
}>;


export type ShopifyConnectionWithThemeQuery = { __typename?: 'Query', shopifyConnection?: { __typename?: 'ShopifyConnection', id: string, storeId?: number | null, storeUrl: string, isConnected: boolean, shopifyThemeIsSupported: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string } } | null };

export type StripePriceFieldsFragment = { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null };

export type SubscriptionPlanFieldsFragment = { __typename?: 'SubscriptionPlan', id: string, name: string, displayName?: string | null, features: Array<SubscriptionFeature>, isAutoApplied: boolean, priceMonthly?: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } | null, priceYearly?: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } | null };

export type AvailableSubscriptionPlansQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type AvailableSubscriptionPlansQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, subscriptions: Array<{ __typename?: 'BrandSubscription', id: string, subscriptionPlan: { __typename?: 'SubscriptionPlan', id: string, name: string, displayName?: string | null, features: Array<SubscriptionFeature>, isAutoApplied: boolean, priceMonthly?: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } | null, priceYearly?: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } | null } }>, availableSubscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, name: string, displayName?: string | null, features: Array<SubscriptionFeature>, isAutoApplied: boolean, priceMonthly?: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } | null, priceYearly?: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null } | null }> } | null };

export type CreateBrandSubscriptionMutationVariables = Exact<{
  brandId: Scalars['ID'];
  subscriptionPlanId: Scalars['ID'];
}>;


export type CreateBrandSubscriptionMutation = { __typename?: 'Mutation', createBrandSubscription: { __typename?: 'BrandSubscription', id: string } };

export type CreateSubscriptionCheckoutSessionMutationVariables = Exact<{
  subscriptionPlanId: Scalars['ID'];
  brandId: Scalars['ID'];
  priceId: Scalars['ID'];
  additionalProduct?: InputMaybe<CheckoutSessionAdditionalProduct>;
}>;


export type CreateSubscriptionCheckoutSessionMutation = { __typename?: 'Mutation', createSubscriptionCheckoutSession: { __typename?: 'StripeCheckoutSession', id: string, url: string } };

export type CurrentSubscriptionsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type CurrentSubscriptionsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, subscriptions: Array<{ __typename?: 'BrandSubscription', id: string, invoices: Array<{ __typename?: 'StripeInvoice', id: string, number: string, amount_due: number, amount_paid: number, currency: string, hosted_invoice_url: string, invoice_pdf: string, created: number, status: string }>, stripeSubscription?: { __typename?: 'StripeSubscription', id: string, currency: string, price: { __typename?: 'StripePrice', id: string, currency: string, type: string, unit_amount?: number | null, recurring?: { __typename?: 'StripeRecurringPrice', interval: string, interval_count: number } | null }, paymentMethod?: { __typename?: 'StripePaymentMethod', id: string, cardBrand?: string | null, cardLastDigits?: string | null } | null } | null, subscriptionPlan: { __typename?: 'SubscriptionPlan', id: string, name: string, displayName?: string | null, features: Array<SubscriptionFeature> } }> } | null };

export type ConnectedProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConnectedProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, name: string, description: string, defaultImageUrl?: string | null, minPrice?: number | null, maxPrice?: number | null, currency?: string | null, externalAdminUrl?: string | null, externalId?: string | null, variants: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, name: string, retailPrice: number, salePrice: number, limitToSupertesters: boolean, quantityAvailable: number, maximumQuantitySellable?: number | null, shippingReadinessChecks: Array<{ __typename?: 'ShippingReadinessCheck', id: string, status: ShippingReadinessCheckStatus, result?: { __typename?: 'BagShippingMethods', shipping_methods: Array<{ __typename?: 'BagShippingMethod', label?: string | null, price?: number | null }> } | null }> }> } };

export type CreateProductDropMutationVariables = Exact<{
  brandId: Scalars['ID'];
  input: ProductDropInput;
}>;


export type CreateProductDropMutation = { __typename?: 'Mutation', createProductDrop: { __typename?: 'ProductDrop', id: string, isSoldOut: boolean, dropsAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, visibleAfter?: string | null, visibleUntil?: string | null, position: number, heroImageFullPath?: string | null, isPromoted: boolean, hasDropped: boolean, productId?: number | null, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null, primaryImageProminentColorHex?: string | null }, product?: { __typename?: 'Product', id: string, quantitySold?: number | null, name: string, description: string, defaultImageUrl?: string | null, maximumQuantitySellable?: number | null, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, name: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } | null } };

export type ShippingReadinessFieldsFragment = { __typename?: 'ShippingReadinessCheck', id: string, status: ShippingReadinessCheckStatus, result?: { __typename?: 'BagShippingMethods', shipping_methods: Array<{ __typename?: 'BagShippingMethod', label?: string | null, price?: number | null }> } | null };

export type CreateShippingReadinessCheckMutationVariables = Exact<{
  productVariantID: Scalars['ID'];
}>;


export type CreateShippingReadinessCheckMutation = { __typename?: 'Mutation', createShippingReadinessCheck: { __typename?: 'ShippingReadinessCheck', id: string, status: ShippingReadinessCheckStatus, result?: { __typename?: 'BagShippingMethods', shipping_methods: Array<{ __typename?: 'BagShippingMethod', label?: string | null, price?: number | null }> } | null } };

export type FullProductDropFieldsFragment = { __typename?: 'ProductDrop', id: string, isSoldOut: boolean, dropsAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, visibleAfter?: string | null, visibleUntil?: string | null, position: number, heroImageFullPath?: string | null, isPromoted: boolean, hasDropped: boolean, productId?: number | null, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null, primaryImageProminentColorHex?: string | null }, product?: { __typename?: 'Product', id: string, quantitySold?: number | null, name: string, description: string, defaultImageUrl?: string | null, maximumQuantitySellable?: number | null, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, name: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } | null };

export type FullProductDropQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FullProductDropQuery = { __typename?: 'Query', productDrop?: { __typename?: 'ProductDrop', id: string, isSoldOut: boolean, dropsAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, visibleAfter?: string | null, visibleUntil?: string | null, position: number, heroImageFullPath?: string | null, isPromoted: boolean, hasDropped: boolean, productId?: number | null, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null, primaryImageProminentColorHex?: string | null }, product?: { __typename?: 'Product', id: string, quantitySold?: number | null, name: string, description: string, defaultImageUrl?: string | null, maximumQuantitySellable?: number | null, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, name: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } | null } | null };

export type UpdateProductDropMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ProductDropInput;
}>;


export type UpdateProductDropMutation = { __typename?: 'Mutation', updateProductDrop: { __typename?: 'ProductDrop', id: string, isSoldOut: boolean, dropsAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, visibleAfter?: string | null, visibleUntil?: string | null, position: number, heroImageFullPath?: string | null, isPromoted: boolean, hasDropped: boolean, productId?: number | null, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null, primaryImageProminentColorHex?: string | null }, product?: { __typename?: 'Product', id: string, quantitySold?: number | null, name: string, description: string, defaultImageUrl?: string | null, maximumQuantitySellable?: number | null, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, name: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } | null } };

export type BrandContributorApplicationQueryVariables = Exact<{
  brandId: Scalars['Int'];
}>;


export type BrandContributorApplicationQuery = { __typename?: 'Query', contributorApplication?: { __typename?: 'ContributorApplication', id: string, status: ContributorApplicationStatus, email: string, brand: { __typename?: 'Brand', id: string, slug: string } } | null };

export type ContributorApplicationMutationVariables = Exact<{
  input: ContributorApplicationInput;
}>;


export type ContributorApplicationMutation = { __typename?: 'Mutation', createContributorApplication: { __typename?: 'ContributorApplication', id: string, status: ContributorApplicationStatus, email: string, brand: { __typename?: 'Brand', id: string, slug: string } } };

export type ContributionEligibilityQueryVariables = Exact<{
  brandId: Scalars['Int'];
}>;


export type ContributionEligibilityQuery = { __typename?: 'Query', eligibileToContributeToBrand: boolean };

export type FetchExternalLinkDataMutationVariables = Exact<{
  url: Scalars['String'];
}>;


export type FetchExternalLinkDataMutation = { __typename?: 'Mutation', fetchExternalLinkData: { __typename?: 'ExternalLinkData', id: string, ogTitle?: string | null, imageUrl?: string | null, imageStorageRef?: string | null, requestUrl: string } };

export type GetLatestSpottedStoryQueryVariables = Exact<{
  latestSpotted: Scalars['Boolean'];
}>;


export type GetLatestSpottedStoryQuery = { __typename?: 'Query', story?: { __typename?: 'Story', id: string, slug?: string | null } | null };

export type GetBrandsSearchQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  order?: InputMaybe<BrandSortOrder>;
  brandIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  status?: InputMaybe<BrandFilterStatus>;
}>;


export type GetBrandsSearchQuery = { __typename?: 'Query', brands: { __typename?: 'BrandsResponse', total: number, hasMore: boolean, items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> }> } };

export type BrandRowFieldsFragment = { __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> };

export type GetBrandsDiscoveryQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  exclude?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  order?: InputMaybe<BrandSortOrder>;
  category?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  demographics?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingDestinations?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  includePromotions?: InputMaybe<Scalars['Boolean']>;
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBrandsDiscoveryQuery = { __typename?: 'Query', brands: { __typename?: 'BrandsResponse', queryID?: string | null, total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> }> } };

export type GetBrandReviewSummaryQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetBrandReviewSummaryQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, slug: string, title: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, myReview?: { __typename?: 'Review', id: string } | null, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null } | null };

export type BrandStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandStatisticsQuery = { __typename?: 'Query', brandListStatistics: Array<{ __typename?: 'BrandListStatistic', id: string, numberOfLists: number, title: string, slug: string }> };

export type BrandStoriesQueryVariables = Exact<{
  brandId: Scalars['ID'];
  includeDrafts: Scalars['Boolean'];
}>;


export type BrandStoriesQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, stories: Array<{ __typename?: 'Story', id: string, slug?: string | null, title?: string | null, document?: any | null, imageFullPath?: string | null, metaDescription?: string | null, publishedAt?: string | null, status: StoryStatus, authorId?: number | null, categoryIds: Array<string>, createdAt: string, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } }> } | null };

export type DiscountCodeFieldsFragment = { __typename?: 'DiscountCode', title: string, code: string, limitToSupertesters?: boolean | null };

export type GetBrandBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetBrandBySlugQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, slug: string, title: string, titleTag?: string | null, rip: boolean, description?: string | null, descriptionFromBrand?: string | null, primaryImageFullPath?: string | null, primaryImageCredit?: string | null, assetsFolder: string, webUrl?: string | null, claimed: boolean, demographics: any, shipsTo: any, status: BrandStatus, hasDiscountCodes: boolean, hasPublicDiscountCodes: boolean, instagramReviewUrl?: string | null, secondaryImages: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, myReview?: { __typename?: 'Review', id: string } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, discountCodes?: Array<{ __typename?: 'DiscountCode', title: string, code: string, limitToSupertesters?: boolean | null }> | null, people?: { __typename?: 'BrandPeopleData', demographics?: Array<string> | null, founders?: Array<{ __typename?: 'Person', name: string }> | null } | null, company?: { __typename?: 'BrandCompanyData', dateFounded?: string | null, dateLaunched?: string | null, hqLocation?: string | null, instagram?: string | null, twitter?: string | null, linkedinUrl?: any | null, facebookUrl?: any | null, tiktokUrl?: any | null, youtubeUrl?: any | null, pintrestUrl?: any | null, certificates?: Array<string> | null } | null, externalLinks?: Array<{ __typename?: 'ExternalLink', storageId: string, imageUrl?: string | null, title?: string | null, url: string }> | null, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null, addedBy: { __typename?: 'User', id: string, username: string, fullName?: string | null, avatarFullPath?: string | null }, productDrops: Array<{ __typename?: 'ProductDrop', id: string, isPromoted: boolean, dropsAt?: string | null, hasDropped: boolean, heroImageFullPath?: string | null, isSoldOut: boolean, nextDropAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, isVisible: boolean, canParticipate: boolean, hasPurchased: boolean, product?: { __typename?: 'Product', id: string, name: string, minPrice?: number | null, currency?: string | null, defaultImageUrl?: string | null, description: string, isSoldOut: boolean, extraInfoLink?: string | null, extraInfoLabel?: string | null, variantsMap: Array<{ __typename?: 'ProductVariantMap', name: string, display_order?: number | null, values: Array<{ __typename?: 'ProductVariantMapValue', name: string, sku_ids: Array<number>, display_order?: number | null }> }>, variants: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku: string, salePrice: number, retailPrice: number, inStock: boolean, productId: string, limitToSupertesters: boolean, primaryImageUrl?: string | null, variantValues: Array<{ __typename?: 'ProductVariantValue', variant: string, value: string }> }> } | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> } }>, reviewAiSummary?: { __typename?: 'ReviewAiSummary', summary: string, strengths: Array<string>, weaknesses: Array<string> } | null } | null };

export type GetBrandRedirectSlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetBrandRedirectSlugQuery = { __typename?: 'Query', findBrandRedirect?: { __typename?: 'Brand', slug: string } | null };

export type MoveUploadToBrandAssetFolderMutationVariables = Exact<{
  assetsFolder: Scalars['String'];
  id: Scalars['Int'];
}>;


export type MoveUploadToBrandAssetFolderMutation = { __typename?: 'Mutation', moveMediaUploadToBrandAssetFolder: { __typename?: 'MediaUpload', id: string, credit?: string | null, caption?: string | null, filePath: string } };

export type BrandPreviewQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type BrandPreviewQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, primaryImageFullPath?: string | null, primaryImageProminentColorHex?: string | null, description?: string | null, myReview?: { __typename?: 'Review', id: string } | null, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null } | null };

export type ReviewableBrandProductsQueryVariables = Exact<{
  brandId: Scalars['ID'];
  order?: InputMaybe<BrandProductSortOrder>;
  onlyWithReviews?: InputMaybe<Scalars['Boolean']>;
}>;


export type ReviewableBrandProductsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, title: string, reviewableProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string, numberOfReviews: number }> } | null };

export type BrandSortOrderQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandSortOrderQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, sortOrderWeight: number, sortOrderWeightBreakdown: any } | null };

export type EditBrandFieldsFragment = { __typename?: 'Brand', id: string, title: string, slug: string, status: BrandStatus, rip: boolean, description?: string | null, descriptionFromBrand?: string | null, impactInitiatives?: string | null, assetsFolder: string, primaryImageCredit?: string | null, primaryImageFullPath?: string | null, primaryImageUploaderType?: PrimaryImageUploaderType | null, publishedAt?: string | null, webUrl?: string | null, alternativeWebUrls: Array<string>, keywords?: string | null, categoryIds: Array<number>, createdAt: string, updatedAt: string, shipsTo: any, instagramReviewUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string }>, discountCodes?: Array<{ __typename?: 'DiscountCode', title: string, code: string, expiryDate?: string | null, limitToSupertesters?: boolean | null }> | null, people?: { __typename?: 'BrandPeopleData', demographics?: Array<string> | null, founders?: Array<{ __typename?: 'Person', name: string }> | null } | null, company?: { __typename?: 'BrandCompanyData', certificates?: Array<string> | null, retail?: boolean | null, dateFounded?: string | null, dateLaunched?: string | null, hqLocation?: string | null, instagram?: string | null, twitter?: string | null, facebookUrl?: any | null, linkedinUrl?: any | null, tiktokUrl?: any | null, pintrestUrl?: any | null, youtubeUrl?: any | null, hqGps?: { __typename?: 'GeoCoordinate', latitude?: string | null, longitude?: string | null } | null } | null, externalLinks?: Array<{ __typename?: 'ExternalLink', imageUrl?: string | null, storageId: string, title?: string | null, url: string }> | null, addedBy: { __typename?: 'User', id: string, fullName?: string | null, username: string }, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null, secondaryImages: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, credit?: string | null, caption?: string | null }>, reviewableProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, numberOfReviews: number, slug: string }> };

export type GetFullBrandQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetFullBrandQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, title: string, slug: string, status: BrandStatus, rip: boolean, description?: string | null, descriptionFromBrand?: string | null, impactInitiatives?: string | null, assetsFolder: string, primaryImageCredit?: string | null, primaryImageFullPath?: string | null, primaryImageUploaderType?: PrimaryImageUploaderType | null, publishedAt?: string | null, webUrl?: string | null, alternativeWebUrls: Array<string>, keywords?: string | null, categoryIds: Array<number>, createdAt: string, updatedAt: string, shipsTo: any, instagramReviewUrl?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string }>, discountCodes?: Array<{ __typename?: 'DiscountCode', title: string, code: string, expiryDate?: string | null, limitToSupertesters?: boolean | null }> | null, people?: { __typename?: 'BrandPeopleData', demographics?: Array<string> | null, founders?: Array<{ __typename?: 'Person', name: string }> | null } | null, company?: { __typename?: 'BrandCompanyData', certificates?: Array<string> | null, retail?: boolean | null, dateFounded?: string | null, dateLaunched?: string | null, hqLocation?: string | null, instagram?: string | null, twitter?: string | null, facebookUrl?: any | null, linkedinUrl?: any | null, tiktokUrl?: any | null, pintrestUrl?: any | null, youtubeUrl?: any | null, hqGps?: { __typename?: 'GeoCoordinate', latitude?: string | null, longitude?: string | null } | null } | null, externalLinks?: Array<{ __typename?: 'ExternalLink', imageUrl?: string | null, storageId: string, title?: string | null, url: string }> | null, addedBy: { __typename?: 'User', id: string, fullName?: string | null, username: string }, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null, secondaryImages: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, credit?: string | null, caption?: string | null }>, reviewableProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, numberOfReviews: number, slug: string }> } | null };

export type PromotedProductOfferCampaignQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type PromotedProductOfferCampaignQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, promotedProductOfferCampaign?: { __typename?: 'ProductOfferCampaign', id: string, title: string, imageFullPath?: string | null } | null } | null };

export type RandomBrandQueryVariables = Exact<{ [key: string]: never; }>;


export type RandomBrandQuery = { __typename?: 'Query', randomBrand: { __typename?: 'Brand', id: string, slug: string } };

export type RelatedBrandsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type RelatedBrandsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, relatedBrands: { __typename?: 'RelatedBrandsResponse', category?: { __typename?: 'Category', id: string, name: string, slug: string } | null, items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> }> } } | null };

export type SubmitBrandMutationVariables = Exact<{
  input: BrandSubmissionInput;
}>;


export type SubmitBrandMutation = { __typename?: 'Mutation', submitBrand: { __typename?: 'BrandSubmissionResult', isNew: boolean, eligibleToContribute: boolean, isPotentialDuplicate?: boolean | null, duplicateHasBeenLogged?: boolean | null, brand: { __typename?: 'Brand', createdAt: string, id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, addedBy: { __typename?: 'User', id: string, fullName?: string | null, username: string }, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> } } };

export type CategoriesQueryVariables = Exact<{
  onlyRoots?: InputMaybe<Scalars['Boolean']>;
  parentIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string, description?: string | null, metaDescription?: string | null, slug: string, parent?: { __typename?: 'Category', id: string, name: string, slug: string } | null, children?: Array<{ __typename?: 'Category', id: string, name: string, slug: string }> | null }> };

export type GetCategoryQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCategoryQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: string, slug: string, name: string, description?: string | null, children?: Array<{ __typename?: 'Category', id: string, slug: string, name: string }> | null } | null };

export type CartFieldsFragment = { __typename?: 'Cart', id: string, stripePublicKey?: string | null, paymentIntentClientSecret?: string | null, total?: number | null, taxTotal?: number | null, subTotal?: number | null, shippingTotal?: number | null, currency?: string | null, currencySymbol?: string | null, isPriced: boolean, status: string, hasPhysicalVariants: boolean, errors: Array<string>, skuIds: Array<string>, shippingCountries: Array<{ __typename?: 'ShippingCountry', name: string, code: string, states?: Array<{ __typename?: 'ShippingState', name: string, code: string }> | null }>, customer?: { __typename?: 'CartCustomer', email: string, first_name: string, last_name: string } | null, shippingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, billingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, bags: Array<{ __typename?: 'CartBag', id: number, merchant_name: string, merchant?: { __typename?: 'Merchant', id: string, supportUrl?: string | null, supportEmail?: string | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string } } | null, shipping_method?: { __typename?: 'CartBagShippingMethod', shipping_method_id: string, type?: string | null, price?: number | null } | null, skus: Array<{ __typename?: 'CartBagSku', id: string, sku_id: string, name: string, thumbnail?: string | null, brand: string, quantity: number, line_price?: number | null, product_type?: ProductType | null, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, inStock: boolean, product: { __typename?: 'Product', id: string, name: string, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } } | null }> }> };

export type ShippingMethodsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShippingMethodsQuery = { __typename?: 'Query', cartShippingMethods: Array<{ __typename?: 'BagShippingMethods', bag_id: number, shipping_methods: Array<{ __typename?: 'BagShippingMethod', shipping_method_id: string, type?: string | null, carrier?: string | null, label?: string | null, price?: number | null }> }> };

export type CartQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CartQuery = { __typename?: 'Query', cart: { __typename?: 'Cart', id: string, stripePublicKey?: string | null, paymentIntentClientSecret?: string | null, total?: number | null, taxTotal?: number | null, subTotal?: number | null, shippingTotal?: number | null, currency?: string | null, currencySymbol?: string | null, isPriced: boolean, status: string, hasPhysicalVariants: boolean, errors: Array<string>, skuIds: Array<string>, shippingCountries: Array<{ __typename?: 'ShippingCountry', name: string, code: string, states?: Array<{ __typename?: 'ShippingState', name: string, code: string }> | null }>, customer?: { __typename?: 'CartCustomer', email: string, first_name: string, last_name: string } | null, shippingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, billingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, bags: Array<{ __typename?: 'CartBag', id: number, merchant_name: string, merchant?: { __typename?: 'Merchant', id: string, supportUrl?: string | null, supportEmail?: string | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string } } | null, shipping_method?: { __typename?: 'CartBagShippingMethod', shipping_method_id: string, type?: string | null, price?: number | null } | null, skus: Array<{ __typename?: 'CartBagSku', id: string, sku_id: string, name: string, thumbnail?: string | null, brand: string, quantity: number, line_price?: number | null, product_type?: ProductType | null, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, inStock: boolean, product: { __typename?: 'Product', id: string, name: string, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } } | null }> }> } };

export type CreateCartMutationVariables = Exact<{
  productVariants: Array<CartSkuUpdateInput> | CartSkuUpdateInput;
}>;


export type CreateCartMutation = { __typename?: 'Mutation', createCart: { __typename?: 'Cart', id: string, stripePublicKey?: string | null, paymentIntentClientSecret?: string | null, total?: number | null, taxTotal?: number | null, subTotal?: number | null, shippingTotal?: number | null, currency?: string | null, currencySymbol?: string | null, isPriced: boolean, status: string, hasPhysicalVariants: boolean, errors: Array<string>, skuIds: Array<string>, shippingCountries: Array<{ __typename?: 'ShippingCountry', name: string, code: string, states?: Array<{ __typename?: 'ShippingState', name: string, code: string }> | null }>, customer?: { __typename?: 'CartCustomer', email: string, first_name: string, last_name: string } | null, shippingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, billingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, bags: Array<{ __typename?: 'CartBag', id: number, merchant_name: string, merchant?: { __typename?: 'Merchant', id: string, supportUrl?: string | null, supportEmail?: string | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string } } | null, shipping_method?: { __typename?: 'CartBagShippingMethod', shipping_method_id: string, type?: string | null, price?: number | null } | null, skus: Array<{ __typename?: 'CartBagSku', id: string, sku_id: string, name: string, thumbnail?: string | null, brand: string, quantity: number, line_price?: number | null, product_type?: ProductType | null, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, inStock: boolean, product: { __typename?: 'Product', id: string, name: string, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } } | null }> }> } };

export type GetPaymentIntentClientSecretMutationVariables = Exact<{
  cartId: Scalars['ID'];
}>;


export type GetPaymentIntentClientSecretMutation = { __typename?: 'Mutation', getPaymentIntentClientSecret: { __typename?: 'Cart', id: string, stripePublicKey?: string | null, paymentIntentClientSecret?: string | null, total?: number | null, taxTotal?: number | null, subTotal?: number | null, shippingTotal?: number | null, currency?: string | null, currencySymbol?: string | null, isPriced: boolean, status: string, hasPhysicalVariants: boolean, errors: Array<string>, skuIds: Array<string>, shippingCountries: Array<{ __typename?: 'ShippingCountry', name: string, code: string, states?: Array<{ __typename?: 'ShippingState', name: string, code: string }> | null }>, customer?: { __typename?: 'CartCustomer', email: string, first_name: string, last_name: string } | null, shippingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, billingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, bags: Array<{ __typename?: 'CartBag', id: number, merchant_name: string, merchant?: { __typename?: 'Merchant', id: string, supportUrl?: string | null, supportEmail?: string | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string } } | null, shipping_method?: { __typename?: 'CartBagShippingMethod', shipping_method_id: string, type?: string | null, price?: number | null } | null, skus: Array<{ __typename?: 'CartBagSku', id: string, sku_id: string, name: string, thumbnail?: string | null, brand: string, quantity: number, line_price?: number | null, product_type?: ProductType | null, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, inStock: boolean, product: { __typename?: 'Product', id: string, name: string, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } } | null }> }> } };

export type SelectShippingMethodsMutationVariables = Exact<{
  shippingMethods: Array<ShippingMethodInput> | ShippingMethodInput;
  cartId: Scalars['ID'];
}>;


export type SelectShippingMethodsMutation = { __typename?: 'Mutation', selectShippingMethodsAndGetPaymentIntentSecret: { __typename?: 'Cart', id: string, stripePublicKey?: string | null, paymentIntentClientSecret?: string | null, total?: number | null, taxTotal?: number | null, subTotal?: number | null, shippingTotal?: number | null, currency?: string | null, currencySymbol?: string | null, isPriced: boolean, status: string, hasPhysicalVariants: boolean, errors: Array<string>, skuIds: Array<string>, shippingCountries: Array<{ __typename?: 'ShippingCountry', name: string, code: string, states?: Array<{ __typename?: 'ShippingState', name: string, code: string }> | null }>, customer?: { __typename?: 'CartCustomer', email: string, first_name: string, last_name: string } | null, shippingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, billingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, bags: Array<{ __typename?: 'CartBag', id: number, merchant_name: string, merchant?: { __typename?: 'Merchant', id: string, supportUrl?: string | null, supportEmail?: string | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string } } | null, shipping_method?: { __typename?: 'CartBagShippingMethod', shipping_method_id: string, type?: string | null, price?: number | null } | null, skus: Array<{ __typename?: 'CartBagSku', id: string, sku_id: string, name: string, thumbnail?: string | null, brand: string, quantity: number, line_price?: number | null, product_type?: ProductType | null, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, inStock: boolean, product: { __typename?: 'Product', id: string, name: string, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } } | null }> }> } };

export type UpdateCartMutationVariables = Exact<{
  id: Scalars['ID'];
  productVariants: Array<CartSkuUpdateInput> | CartSkuUpdateInput;
}>;


export type UpdateCartMutation = { __typename?: 'Mutation', updateCart: { __typename?: 'Cart', id: string, stripePublicKey?: string | null, paymentIntentClientSecret?: string | null, total?: number | null, taxTotal?: number | null, subTotal?: number | null, shippingTotal?: number | null, currency?: string | null, currencySymbol?: string | null, isPriced: boolean, status: string, hasPhysicalVariants: boolean, errors: Array<string>, skuIds: Array<string>, shippingCountries: Array<{ __typename?: 'ShippingCountry', name: string, code: string, states?: Array<{ __typename?: 'ShippingState', name: string, code: string }> | null }>, customer?: { __typename?: 'CartCustomer', email: string, first_name: string, last_name: string } | null, shippingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, billingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, bags: Array<{ __typename?: 'CartBag', id: number, merchant_name: string, merchant?: { __typename?: 'Merchant', id: string, supportUrl?: string | null, supportEmail?: string | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string } } | null, shipping_method?: { __typename?: 'CartBagShippingMethod', shipping_method_id: string, type?: string | null, price?: number | null } | null, skus: Array<{ __typename?: 'CartBagSku', id: string, sku_id: string, name: string, thumbnail?: string | null, brand: string, quantity: number, line_price?: number | null, product_type?: ProductType | null, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, inStock: boolean, product: { __typename?: 'Product', id: string, name: string, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } } | null }> }> } };

export type UpdateCartCustomerMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CartCustomerInput;
}>;


export type UpdateCartCustomerMutation = { __typename?: 'Mutation', updateCartCustomer: { __typename?: 'Cart', id: string, stripePublicKey?: string | null, paymentIntentClientSecret?: string | null, total?: number | null, taxTotal?: number | null, subTotal?: number | null, shippingTotal?: number | null, currency?: string | null, currencySymbol?: string | null, isPriced: boolean, status: string, hasPhysicalVariants: boolean, errors: Array<string>, skuIds: Array<string>, shippingCountries: Array<{ __typename?: 'ShippingCountry', name: string, code: string, states?: Array<{ __typename?: 'ShippingState', name: string, code: string }> | null }>, customer?: { __typename?: 'CartCustomer', email: string, first_name: string, last_name: string } | null, shippingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, billingAddress?: { __typename?: 'CartShippingAddress', address_1: string, address_2?: string | null, city: string, postal_code: string, state: string, country: string } | null, bags: Array<{ __typename?: 'CartBag', id: number, merchant_name: string, merchant?: { __typename?: 'Merchant', id: string, supportUrl?: string | null, supportEmail?: string | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string } } | null, shipping_method?: { __typename?: 'CartBagShippingMethod', shipping_method_id: string, type?: string | null, price?: number | null } | null, skus: Array<{ __typename?: 'CartBagSku', id: string, sku_id: string, name: string, thumbnail?: string | null, brand: string, quantity: number, line_price?: number | null, product_type?: ProductType | null, productVariant?: { __typename?: 'ProductVariant', id: string, name: string, inStock: boolean, product: { __typename?: 'Product', id: string, name: string, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: string, states?: Array<{ __typename?: 'ShippingState', code: string, name: string }> | null }> } } | null }> }> } };

export type PopularBrandsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PopularBrandsQuery = { __typename?: 'Query', popularBrands: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> }> };

export type TopReviewersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
}>;


export type TopReviewersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResponse', items: Array<{ __typename?: 'User', id: string, username: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }> } };

export type UserPreviewQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']>;
  reviewCount?: InputMaybe<Scalars['Int']>;
}>;


export type UserPreviewQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, bio?: string | null, username: string, fullName?: string | null, reviewCount: number, createdAt: string, location?: string | null, verificationStatus: VerificationStatus, avatarFullPath?: string | null, level: number, reviews: { __typename?: 'ReviewsResponse', items: Array<{ __typename?: 'Review', id: string, brand: { __typename?: 'Brand', id: string, primaryImageFullPath?: string | null, title: string, slug: string } }> } } | null };

export type CreateMediaUploadMutationVariables = Exact<{
  filePath: Scalars['String'];
  type?: InputMaybe<MediaUploadType>;
}>;


export type CreateMediaUploadMutation = { __typename?: 'Mutation', createMediaUpload: { __typename?: 'MediaUpload', id: string, type: MediaUploadType, urlTemplate: string } };

export type MediaUploadQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MediaUploadQuery = { __typename?: 'Query', mediaUpload: { __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null } };

export type GetCreatedReviewKarmaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatedReviewKarmaQuery = { __typename?: 'Query', karmaAmount: { __typename?: 'KarmaAmount', WROTE_REVIEW: number, ADDED_MEDIA_IN_REVIEW: number, REVIEWED_THINGDROP: number, FIRST_REVIEWER_OF_BRAND: number, ADDED_RATING_ONLY_REVIEW: number } };

export type MapBrandCoordinatesQueryVariables = Exact<{ [key: string]: never; }>;


export type MapBrandCoordinatesQuery = { __typename?: 'Query', brandCoordinates: Array<{ __typename?: 'BrandCoordinates', id: string, title: string, slug: string, coordinates: { __typename?: 'GeoCoordinate', latitude?: string | null, longitude?: string | null } }> };

export type MediaUploadFieldsFragment = { __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null };

export type FeaturedListsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturedListsQuery = { __typename?: 'Query', featuredLists: Array<{ __typename?: 'List', id: string, title: string, description?: string | null, user: { __typename?: 'User', id: string, username: string, fullName?: string | null }, brands: { __typename?: 'ListBrandsResponse', items: Array<{ __typename?: 'Brand', id: string, primaryImageFullPath?: string | null }> } }> };

export type ListFieldsFragment = { __typename?: 'List', id: string, title: string, description?: string | null, type: ListType, isSpecial: boolean, isPrivate: boolean };

export type ListBrandsFieldsFragment = { __typename?: 'List', brands: { __typename?: 'ListBrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, primaryImageFullPath?: string | null }> } };

export type MemberDeleteListMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MemberDeleteListMutation = { __typename?: 'Mutation', deleteList: { __typename?: 'SuccessResponse', success: boolean } };

export type MemberEditListMutationVariables = Exact<{
  input: ListInput;
  id: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type MemberEditListMutation = { __typename?: 'Mutation', updateList: { __typename?: 'List', id: string, title: string, description?: string | null, type: ListType, isSpecial: boolean, isPrivate: boolean, brands: { __typename?: 'ListBrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, primaryImageFullPath?: string | null }> } } };

export type MemberCreateListMutationVariables = Exact<{
  input: ListInput;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type MemberCreateListMutation = { __typename?: 'Mutation', createList: { __typename?: 'List', id: string, title: string, description?: string | null, type: ListType, isSpecial: boolean, isPrivate: boolean, brands: { __typename?: 'ListBrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, primaryImageFullPath?: string | null }> } } };

export type ListQueryVariables = Exact<{
  id: Scalars['ID'];
  username: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type ListQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, title: string, description?: string | null, type: ListType, isSpecial: boolean, isPrivate: boolean, brands: { __typename?: 'ListBrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> }> }, user: { __typename?: 'User', id: string, fullName?: string | null, username: string } } | null };

export type MemberGetBrandListsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type MemberGetBrandListsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, lists: Array<{ __typename?: 'List', id: string, title: string, type: ListType }> } | null };

export type ViewBrandMutationVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type ViewBrandMutation = { __typename?: 'Mutation', createBrandView: { __typename?: 'AddOrRemoveListBrandResponse', list: { __typename?: 'List', id: string }, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null } } };

export type GetListsQueryVariables = Exact<{
  listIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetListsQuery = { __typename?: 'Query', lists: Array<{ __typename?: 'List', id: string, title: string, description?: string | null, type: ListType, isSpecial: boolean, isPrivate: boolean, user: { __typename?: 'User', id: string, fullName?: string | null, username: string }, brands: { __typename?: 'ListBrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> }> } }> };

export type BrandListDetailsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandListDetailsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, likesCount: number, lists: Array<{ __typename?: 'List', id: string, type: ListType }> } | null };

export type MemberAddOrRemoveBrandFromListMutationVariables = Exact<{
  listId?: InputMaybe<Scalars['Int']>;
  listType?: InputMaybe<ListType>;
  brandId: Scalars['ID'];
}>;


export type MemberAddOrRemoveBrandFromListMutation = { __typename?: 'Mutation', addOrRemoveBrandFromList: { __typename?: 'AddOrRemoveListBrandResponse', result: AddOrRemoveResult, list: { __typename?: 'List', id: string, type: ListType }, brand: { __typename?: 'Brand', id: string, likesCount: number, lists: Array<{ __typename?: 'List', id: string, type: ListType }> } } };

export type ViewedBrandFragmentFragment = { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null };

export type ViewedBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewedBrandsQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, brands: { __typename?: 'ListBrandsResponse', items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null }> } } | null };

export type UserListsQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserListsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, username: string, lists: Array<{ __typename?: 'List', id: string, title: string, description?: string | null, type: ListType, isSpecial: boolean, isPrivate: boolean, brands: { __typename?: 'ListBrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, primaryImageFullPath?: string | null }> } }> } | null };

export type OnboardingGetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingGetCategoriesQuery = { __typename?: 'Query', metadataSummary: { __typename?: 'BrandMetadataSummary', categories: Array<string> } };

export type OnboardingGetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingGetProfileQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, bio?: string | null, firstName?: string | null, lastName?: string | null, username: string, jobTitle?: string | null, location?: string | null, level: number, yearOfBirth?: number | null, gender?: Gender | null, personal: { __typename?: 'UserPersonalInfo', pronoun?: Pronoun | null, birthday?: string | null, hasKids?: string | null, hasPets?: string | null }, interests: { __typename?: 'UserInterests', categoryIds?: Array<number> | null }, socialAccounts: { __typename?: 'UserSocialAccounts', instagramUsername?: string | null, twitterUsername?: string | null, tiktokUsername?: string | null, linkedinUrl?: any | null } } | null };

export type OnboardingGetSubcategoriesQueryVariables = Exact<{
  fromCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type OnboardingGetSubcategoriesQuery = { __typename?: 'Query', metadataSummary: { __typename?: 'BrandMetadataSummary', subcategories: Array<string> } };

export type UserReviewImpactQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserReviewImpactQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, username: string, fullName?: string | null, karma: number, level: number, avatarFullPath?: string | null, summary: { __typename?: 'UserSummary', averageRating?: number | null, totalReviews: number, ratingDistribution?: any | null, totalReadsCount: number, totalClapsReceived: number }, latestReview: { __typename?: 'ReviewsResponse', items: Array<{ __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> }> }, mostReadReview: { __typename?: 'ReviewsResponse', items: Array<{ __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> }> } } | null };

export type ChangeEmailMutationVariables = Exact<{
  newEmail: Scalars['String'];
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmailAddress: { __typename?: 'User', id: string, email: string } };

export type SocialAccountsFieldsFragment = { __typename?: 'UserSocialAccounts', instagramUsername?: string | null, twitterUsername?: string | null, tiktokUsername?: string | null, linkedinUrl?: any | null };

export type ProfileFieldsFragment = { __typename?: 'User', id: string, bio?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, username: string, jobTitle?: string | null, location?: string | null, verificationStatus: VerificationStatus, hasCompletedProfile: boolean, hasAddedAdditionalInformation: boolean, avatarFullPath?: string | null, level: number, yearOfBirth?: number | null, gender?: Gender | null, personal: { __typename?: 'UserPersonalInfo', pronoun?: Pronoun | null, birthday?: string | null, hasKids?: string | null, hasPets?: string | null }, interests: { __typename?: 'UserInterests', categoryIds?: Array<number> | null }, socialAccounts: { __typename?: 'UserSocialAccounts', instagramUsername?: string | null, twitterUsername?: string | null, tiktokUsername?: string | null, linkedinUrl?: any | null } };

export type MemberDeleteProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type MemberDeleteProfileMutation = { __typename?: 'Mutation', removeMe: { __typename?: 'SuccessResponse', success: boolean } };

export type MemberUpdateProfileMutationVariables = Exact<{
  input: UserProfileInput;
  validationScope?: InputMaybe<UserProfileInputScope>;
}>;


export type MemberUpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'User', id: string, bio?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, username: string, jobTitle?: string | null, location?: string | null, verificationStatus: VerificationStatus, hasCompletedProfile: boolean, hasAddedAdditionalInformation: boolean, avatarFullPath?: string | null, level: number, yearOfBirth?: number | null, gender?: Gender | null, personal: { __typename?: 'UserPersonalInfo', pronoun?: Pronoun | null, birthday?: string | null, hasKids?: string | null, hasPets?: string | null }, interests: { __typename?: 'UserInterests', categoryIds?: Array<number> | null }, socialAccounts: { __typename?: 'UserSocialAccounts', instagramUsername?: string | null, twitterUsername?: string | null, tiktokUsername?: string | null, linkedinUrl?: any | null } } };

export type MemberProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberProfileQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, bio?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, username: string, jobTitle?: string | null, location?: string | null, verificationStatus: VerificationStatus, hasCompletedProfile: boolean, hasAddedAdditionalInformation: boolean, avatarFullPath?: string | null, level: number, yearOfBirth?: number | null, gender?: Gender | null, personal: { __typename?: 'UserPersonalInfo', pronoun?: Pronoun | null, birthday?: string | null, hasKids?: string | null, hasPets?: string | null }, interests: { __typename?: 'UserInterests', categoryIds?: Array<number> | null }, socialAccounts: { __typename?: 'UserSocialAccounts', instagramUsername?: string | null, twitterUsername?: string | null, tiktokUsername?: string | null, linkedinUrl?: any | null } } | null };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  input: NotificationSettingsInput;
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', updateNotificationSettings: { __typename?: 'SuccessResponse', success: boolean } };

export type SubscriptionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionInfoQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, subscriptions: { __typename?: 'SubscriptionResponse', newsletter?: string | null, notifications?: string | null } } | null };

export type FinalizeMerchantConnectionMutationVariables = Exact<{
  merchantId: Scalars['Int'];
  connectionNonce: Scalars['String'];
}>;


export type FinalizeMerchantConnectionMutation = { __typename?: 'Mutation', finalizeMerchantConnection: { __typename?: 'Merchant', id: string, brand: { __typename?: 'Brand', id: string, slug: string } } };

export type GetMerchantHealthQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type GetMerchantHealthQuery = { __typename?: 'Query', merchant?: { __typename?: 'Merchant', connectionHealth: { __typename?: 'MerchantHealth', payout_account: string } } | null };

export type NotificationTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationTokenMutation = { __typename?: 'Mutation', createNotificationToken: { __typename?: 'SuccessResponse', success: boolean, payload?: any | null } };

export type AvailableTagsQueryVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AvailableTagsQuery = { __typename?: 'Query', availableTags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> };

export type EditReviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EditReviewQuery = { __typename?: 'Query', editReview?: { __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null }, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> } | null };

export type UpdateReviewMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ReviewInput;
}>;


export type UpdateReviewMutation = { __typename?: 'Mutation', updateReview: { __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null }, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> } };

export type CreateReviewMutationVariables = Exact<{
  brandId: Scalars['ID'];
  input: ReviewInput;
}>;


export type CreateReviewMutation = { __typename?: 'Mutation', createReview: { __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null } | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> } };

export type MyTestedListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type MyTestedListQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, type: ListType, brands: { __typename?: 'ListBrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, title: string, primaryImageFullPath?: string | null, slug: string, description?: string | null, hasDiscountCodes: boolean, likesCount: number, status: BrandStatus, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null }> } } | null };

export type MyReviewedBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyReviewedBrandsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, reviews: { __typename?: 'ReviewsResponse', items: Array<{ __typename?: 'Review', id: string, brandId: string }> } } | null };

export type MyReviewsForBrandQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type MyReviewsForBrandQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, reviews: { __typename?: 'ReviewsResponse', items: Array<{ __typename?: 'Review', id: string, brandId: string, stars?: number | null }> } } | null };

export type GetMyTestedListQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMyTestedListQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, type: ListType, brands: { __typename?: 'ListBrandsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> }> } } | null };

export type ReviewTagFieldsFragment = { __typename?: 'Review', tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> };

export type ReviewFieldsFragment = { __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null }, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> };

export type ReviewSummaryFieldsFragment = { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number, wouldRecommendPercent?: number | null, ratingDistribution?: any | null, popularTags?: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> | null };

export type BrandReviewsQueryVariables = Exact<{
  brandId: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  exclude?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  order?: InputMaybe<ReviewSortOrder>;
  ratings?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  brandProductIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BrandReviewsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null, reviews: { __typename?: 'ReviewsResponse', hasMore: boolean, total: number, nextSkip: number, items: Array<{ __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null }, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> }> } } | null };

export type PrivateFeedbackQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type PrivateFeedbackQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, privateFeedback: { __typename?: 'ReviewsResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Review', id: string, bodyPrivate: string, publishedAt?: string | null, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, level: number, reviewCount: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, brand: { __typename?: 'Brand', id: string } }> } } | null };

export type RemoveReviewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveReviewMutation = { __typename?: 'Mutation', removeReview: { __typename?: 'SuccessResponse', success: boolean } };

export type ReportReviewMutationVariables = Exact<{
  id: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type ReportReviewMutation = { __typename?: 'Mutation', reportReview: { __typename?: 'SuccessResponse', success: boolean } };

export type ReviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReviewQuery = { __typename?: 'Query', review?: { __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null }, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> } | null };

export type ReviewReactionsQueryVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type ReviewReactionsQuery = { __typename?: 'Query', review?: { __typename?: 'Review', id: string, reactions: Array<{ __typename?: 'ReviewReaction', id: string, type: ReactionType, anonymousId?: string | null, user?: { __typename?: 'User', id: string, username: string, fullName?: string | null, avatarFullPath?: string | null, reviewCount: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null } | null }> } | null };

export type ReviewTagsQueryVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type ReviewTagsQuery = { __typename?: 'Query', review?: { __typename?: 'Review', id: string, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> } | null };

export type ReviewsQueryVariables = Exact<{
  skipCache?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  brandStatus?: InputMaybe<BrandFilterStatus>;
  withMedia?: InputMaybe<Scalars['Boolean']>;
  withBody?: InputMaybe<Scalars['Boolean']>;
  minimumScore?: InputMaybe<Scalars['Int']>;
  minimumAuthorLevel?: InputMaybe<Scalars['Int']>;
}>;


export type ReviewsQuery = { __typename?: 'Query', reviews: Array<{ __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> }> };

export type ToggleReviewReactionMutationVariables = Exact<{
  reviewId: Scalars['ID'];
  reactionType: ReactionType;
}>;


export type ToggleReviewReactionMutation = { __typename?: 'Mutation', toggleReviewReaction: { __typename?: 'ReactionResponse', result: AddOrRemoveResult, reviewId: string } };

export type ReviewReactionFieldsFragment = { __typename?: 'ReviewReaction', id: string, userId?: string | null, type: ReactionType, reviewId: string };

export type BrandReviewReactionsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandReviewReactionsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, brandReviewReactions: Array<{ __typename?: 'ReviewReaction', id: string, userId?: string | null, type: ReactionType, reviewId: string }> } | null };

export type AnonymousBrandReviewReactionsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type AnonymousBrandReviewReactionsQuery = { __typename?: 'Query', brandReviewReactions: Array<{ __typename?: 'ReviewReaction', id: string, userId?: string | null, type: ReactionType, reviewId: string }> };

export type UserReviewsQueryVariables = Exact<{
  username: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  exclude?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  order?: InputMaybe<UserReviewsOrder>;
}>;


export type UserReviewsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, reviews: { __typename?: 'ReviewsResponse', nextSkip: number, hasMore: boolean, total: number, items: Array<{ __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> }> } } | null };

export type ReviewReplyFieldsFragment = { __typename?: 'ReviewReply', id: string, body?: string | null, type: ReplyType, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, username: string, firstName?: string | null, fullName?: string | null, avatarFullPath?: string | null } };

export type ReviewRepliesQueryVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type ReviewRepliesQuery = { __typename?: 'Query', review?: { __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, replies: Array<{ __typename?: 'ReviewReply', id: string, body?: string | null, type: ReplyType, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, username: string, firstName?: string | null, fullName?: string | null, avatarFullPath?: string | null } }>, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, brand: { __typename?: 'Brand', id: string, title: string, slug: string, primaryImageFullPath?: string | null }, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> } | null };

export type ReviewReplyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReviewReplyQuery = { __typename?: 'Query', reviewReply: { __typename?: 'ReviewReply', id: string, body?: string | null, type: ReplyType, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, username: string, firstName?: string | null, fullName?: string | null, avatarFullPath?: string | null } } };

export type CreateReviewReplyMutationVariables = Exact<{
  reviewId: Scalars['ID'];
  type: ReplyType;
  body?: InputMaybe<Scalars['String']>;
}>;


export type CreateReviewReplyMutation = { __typename?: 'Mutation', createReviewReply: { __typename?: 'ReviewReply', id: string, body?: string | null, type: ReplyType, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, username: string, firstName?: string | null, fullName?: string | null, avatarFullPath?: string | null } } };

export type RemoveReviewReplyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveReviewReplyMutation = { __typename?: 'Mutation', removeReviewReply: { __typename?: 'SuccessResponse', success: boolean } };

export type MyPurchasesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  productIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type MyPurchasesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, purchases: Array<{ __typename?: 'Purchase', createdAt: string, id: string, updatedAt: string, status: PurchaseStatus, product: { __typename?: 'Product', id: string } }> } | null };

export type ProductOfferCampaignQueryVariables = Exact<{
  productOfferCampaignId: Scalars['ID'];
}>;


export type ProductOfferCampaignQuery = { __typename?: 'Query', productOfferCampaign: { __typename?: 'ProductOfferCampaign', title: string, description: string, logoFullPath?: string | null, imageFullPath?: string | null, steps: { __typename?: 'ProductOfferCampaignSteps', payment: { __typename?: 'ProductOfferCampaignStep', header: string, description: string }, storeFinder: { __typename?: 'ProductOfferCampaignStep', ctaText?: string | null, ctaUrl?: string | null, header: string, description: string }, upload: { __typename?: 'ProductOfferCampaignStep', ctaText?: string | null, description: string, header: string } }, productOffer: { __typename?: 'ProductOffer', product: { __typename?: 'Product', id: string, brand: { __typename?: 'Brand', id: string, slug: string } } } } };

export type ProductOfferCampaignsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProductOfferCampaignsQuery = { __typename?: 'Query', productOfferCampaigns: { __typename?: 'ProductOfferCampaignsResponse', items: Array<{ __typename?: 'ProductOfferCampaign', id: string, title: string, imageFullPath?: string | null, productOffer: { __typename?: 'ProductOffer', product: { __typename?: 'Product', id: string, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null } } } }> } };

export type GetPurchaseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPurchaseQuery = { __typename?: 'Query', purchase: { __typename?: 'Purchase', id: string, status: PurchaseStatus, receipts: Array<{ __typename?: 'PurchaseReceipt', status: PurchaseReceiptStatus }>, product: { __typename?: 'Product', id: string, name: string, description: string, defaultImageUrl?: string | null, brand: { __typename?: 'Brand', title: string, slug: string, primaryImageFullPath?: string | null } } } };

export type CreatePurchaseMutationVariables = Exact<{
  productId: Scalars['ID'];
  productOfferCampaignId: Scalars['ID'];
}>;


export type CreatePurchaseMutation = { __typename?: 'Mutation', createPurchase: { __typename?: 'Purchase', createdAt: string, id: string, status: PurchaseStatus, updatedAt: string, product: { __typename?: 'Product', brandId: string, id: string } } };

export type CreatePurchaseReceiptMutationVariables = Exact<{
  input: CreatePurchaseReceiptInput;
}>;


export type CreatePurchaseReceiptMutation = { __typename?: 'Mutation', createPurchaseReceipt: { __typename?: 'PurchaseReceipt', id: string, status: PurchaseReceiptStatus } };

export type PurchaseReimbursementRedirectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PurchaseReimbursementRedirectQuery = { __typename?: 'Query', purchaseReimbursement: { __typename?: 'PurchaseReimbursement', id: string, tremendousRedemptionUrl: string } };

export type CreateSearchApiKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSearchApiKeyMutation = { __typename?: 'Mutation', createSearchApiKey: { __typename?: 'SuccessResponse', payload?: any | null } };

export type PublicStoriesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type PublicStoriesQuery = { __typename?: 'Query', stories: { __typename?: 'StoriesResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } }> } };

export type StoryFieldsFragment = { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } };

export type GetStoryQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetStoryQuery = { __typename?: 'Query', story?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null };

export type GetStoryGridQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  slugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetStoryGridQuery = { __typename?: 'Query', stories: { __typename?: 'StoriesResponse', total: number, hasMore: boolean, nextSkip: number, items: Array<{ __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } }> } };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, name: string, minPrice?: number | null, currency?: string | null, defaultImageUrl?: string | null, description: string, isSoldOut: boolean, extraInfoLink?: string | null, extraInfoLabel?: string | null, variantsMap: Array<{ __typename?: 'ProductVariantMap', name: string, display_order?: number | null, values: Array<{ __typename?: 'ProductVariantMapValue', name: string, sku_ids: Array<number>, display_order?: number | null }> }>, variants: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku: string, salePrice: number, retailPrice: number, inStock: boolean, productId: string, limitToSupertesters: boolean, primaryImageUrl?: string | null, variantValues: Array<{ __typename?: 'ProductVariantValue', variant: string, value: string }> }> };

export type ProductDropFieldsFragment = { __typename?: 'ProductDrop', id: string, isPromoted: boolean, dropsAt?: string | null, hasDropped: boolean, heroImageFullPath?: string | null, isSoldOut: boolean, nextDropAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, isVisible: boolean, canParticipate: boolean, hasPurchased: boolean, product?: { __typename?: 'Product', id: string, name: string, minPrice?: number | null, currency?: string | null, defaultImageUrl?: string | null, description: string, isSoldOut: boolean, extraInfoLink?: string | null, extraInfoLabel?: string | null, variantsMap: Array<{ __typename?: 'ProductVariantMap', name: string, display_order?: number | null, values: Array<{ __typename?: 'ProductVariantMapValue', name: string, sku_ids: Array<number>, display_order?: number | null }> }>, variants: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku: string, salePrice: number, retailPrice: number, inStock: boolean, productId: string, limitToSupertesters: boolean, primaryImageUrl?: string | null, variantValues: Array<{ __typename?: 'ProductVariantValue', variant: string, value: string }> }> } | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> } };

export type ProductDropQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductDropQuery = { __typename?: 'Query', productDrop?: { __typename?: 'ProductDrop', id: string, isPromoted: boolean, dropsAt?: string | null, hasDropped: boolean, heroImageFullPath?: string | null, isSoldOut: boolean, nextDropAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, isVisible: boolean, canParticipate: boolean, hasPurchased: boolean, product?: { __typename?: 'Product', id: string, name: string, minPrice?: number | null, currency?: string | null, defaultImageUrl?: string | null, description: string, isSoldOut: boolean, extraInfoLink?: string | null, extraInfoLabel?: string | null, variantsMap: Array<{ __typename?: 'ProductVariantMap', name: string, display_order?: number | null, values: Array<{ __typename?: 'ProductVariantMapValue', name: string, sku_ids: Array<number>, display_order?: number | null }> }>, variants: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku: string, salePrice: number, retailPrice: number, inStock: boolean, productId: string, limitToSupertesters: boolean, primaryImageUrl?: string | null, variantValues: Array<{ __typename?: 'ProductVariantValue', variant: string, value: string }> }> } | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> } } | null };

export type ProductDropsQueryVariables = Exact<{
  filter?: InputMaybe<ProductDropFilter>;
  sort?: InputMaybe<ProductDropSortOrder>;
  take?: InputMaybe<Scalars['Int']>;
  exclude?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
  isPromoted?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProductDropsQuery = { __typename?: 'Query', productDrops: Array<{ __typename?: 'ProductDrop', id: string, isPromoted: boolean, dropsAt?: string | null, hasDropped: boolean, heroImageFullPath?: string | null, isSoldOut: boolean, nextDropAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, isVisible: boolean, canParticipate: boolean, hasPurchased: boolean, product?: { __typename?: 'Product', id: string, name: string, minPrice?: number | null, currency?: string | null, defaultImageUrl?: string | null, description: string, isSoldOut: boolean, extraInfoLink?: string | null, extraInfoLabel?: string | null, variantsMap: Array<{ __typename?: 'ProductVariantMap', name: string, display_order?: number | null, values: Array<{ __typename?: 'ProductVariantMapValue', name: string, sku_ids: Array<number>, display_order?: number | null }> }>, variants: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku: string, salePrice: number, retailPrice: number, inStock: boolean, productId: string, limitToSupertesters: boolean, primaryImageUrl?: string | null, variantValues: Array<{ __typename?: 'ProductVariantValue', variant: string, value: string }> }> } | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> } }> };

export type BrandProductDropFieldsFragment = { __typename?: 'ProductDrop', id: string, dropsAt?: string | null, visibleAfter?: string | null, visibleUntil?: string | null, isPromoted: boolean, hasDropped: boolean, isSoldOut: boolean, isVisible: boolean, product?: { __typename?: 'Product', id: string, name: string, description: string, defaultImageUrl?: string | null } | null };

export type BrandProductDropsQueryVariables = Exact<{
  slug: Scalars['String'];
  filter?: InputMaybe<ProductDropFilter>;
}>;


export type BrandProductDropsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, productDrops: Array<{ __typename?: 'ProductDrop', id: string, dropsAt?: string | null, visibleAfter?: string | null, visibleUntil?: string | null, isPromoted: boolean, hasDropped: boolean, isSoldOut: boolean, isVisible: boolean, product?: { __typename?: 'Product', id: string, name: string, description: string, defaultImageUrl?: string | null } | null }> } | null };

export type VisibleProductDropsQueryVariables = Exact<{ [key: string]: never; }>;


export type VisibleProductDropsQuery = { __typename?: 'Query', productDrops: Array<{ __typename?: 'ProductDrop', id: string, isPromoted: boolean, dropsAt?: string | null, hasDropped: boolean, heroImageFullPath?: string | null, isSoldOut: boolean, nextDropAt?: string | null, shipsTo?: string | null, backgroundColor?: string | null, isVisible: boolean, canParticipate: boolean, hasPurchased: boolean, product?: { __typename?: 'Product', id: string, name: string, minPrice?: number | null, currency?: string | null, defaultImageUrl?: string | null, description: string, isSoldOut: boolean, extraInfoLink?: string | null, extraInfoLabel?: string | null, variantsMap: Array<{ __typename?: 'ProductVariantMap', name: string, display_order?: number | null, values: Array<{ __typename?: 'ProductVariantMapValue', name: string, sku_ids: Array<number>, display_order?: number | null }> }>, variants: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku: string, salePrice: number, retailPrice: number, inStock: boolean, productId: string, limitToSupertesters: boolean, primaryImageUrl?: string | null, variantValues: Array<{ __typename?: 'ProductVariantValue', variant: string, value: string }> }> } | null, brand: { __typename?: 'Brand', id: string, title: string, slug: string, rip: boolean, description?: string | null, primaryImageFullPath?: string | null, webUrl?: string | null, hasDiscountCodes: boolean, instagramReviewUrl?: string | null, primaryImageProminentColorHex?: string | null, likesCount: number, isPromoted?: boolean | null, status: BrandStatus, milestones: Array<{ __typename?: 'BrandMilestone', type: BrandMilestoneType, completedAt: string }>, myReview?: { __typename?: 'Review', id: string } | null, lists: Array<{ __typename?: 'List', id: string, type: ListType }>, reviewSummary?: { __typename?: 'ReviewSummary', brandId: string, averageRating?: number | null, ratingsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, slug: string, name: string, parentId?: number | null }> } }> };

export type LeaderboardUsersQueryVariables = Exact<{
  take: Scalars['Int'];
  imageCount?: Scalars['Int'];
}>;


export type LeaderboardUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResponse', items: Array<{ __typename?: 'User', id: string, karma: number, level: number, bio?: string | null, username: string, fullName?: string | null, reviewCount: number, avatarFullPath?: string | null, latestReview: { __typename?: 'ReviewsResponse', items: Array<{ __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> }> }, mostReadReview: { __typename?: 'ReviewsResponse', items: Array<{ __typename?: 'Review', id: string, bodyPositive: string, bodyNegative: string, bodyPrivate: string, stars?: number | null, affiliation?: string | null, wouldRecommend?: boolean | null, clapCount: number, replyCount: number, readsCount: number, createdAt: string, publishedAt?: string | null, mediaUploadIds: Array<string>, tagIds: Array<string>, isEditable: boolean, brand: { __typename?: 'Brand', id: string, slug: string, title: string, primaryImageFullPath?: string | null }, brandProducts: Array<{ __typename?: 'BrandProduct', id: string, name: string, slug: string }>, media: Array<{ __typename?: 'MediaUpload', id: string, filePath: string, type: MediaUploadType, transformationStatus: MediaUploadTransformationStatus, caption?: string | null, credit?: string | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, avatarFullPath?: string | null, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, username: string, reviewCount: number, level: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null }, linkedStory?: { __typename?: 'Story', id: string, title?: string | null, slug?: string | null, document?: any | null, metaDescription?: string | null, imageFullPath?: string | null, categoryIds: Array<string>, publishedAt?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string, slug: string, parentId?: number | null }>, author: { __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, avatarFullPath?: string | null, username: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, name: string }> }> }, reviews: { __typename?: 'ReviewsResponse', items: Array<{ __typename?: 'Review', id: string, brand: { __typename?: 'Brand', id: string, primaryImageFullPath?: string | null, title: string, slug: string } }> } }> } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, createdAt: string, firebaseUid: string, avatarFullPath?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, phoneNumber?: string | null, username: string, level: number, karmaRequirementForPreviousLevel?: number | null, karmaRequirementForNextLevel?: number | null, karma: number, bio?: string | null, membershipLevel: MembershipLevel, membershipExpiresAt?: string | null, membershipIsForever?: boolean | null, role: UserRole, specialLists: any, betaTester: boolean, listCount: number, reviewCount: number, verificationStatus: VerificationStatus, hasCompletedProfile: boolean, hasAddedAdditionalInformation: boolean, abilities: any, firstReviewOfBrandCount: number, reviewMediaCount: number, personal: { __typename?: 'UserPersonalInfo', birthday?: string | null, hasKids?: string | null, hasPets?: string | null, pronoun?: Pronoun | null } } | null };

export type SetMyAvatarMutationVariables = Exact<{
  mediaUploadId: Scalars['Int'];
}>;


export type SetMyAvatarMutation = { __typename?: 'Mutation', setAvatar: { __typename?: 'User', id: string, avatarFullPath?: string | null } };

export type NavigationQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type NavigationQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, reviewCount: number, listCount: number } | null };

export type ConsumeInvitationMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConsumeInvitationMutation = { __typename?: 'Mutation', consumeInvitation: { __typename?: 'SuccessResponse', success: boolean } };

export type CreateBrandOwnershipMutationVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type CreateBrandOwnershipMutation = { __typename?: 'Mutation', createBrandSourcedUserBrandOwnership: { __typename?: 'SuccessResponse', success: boolean } };

export type CreateLoginTokenFromInvitationMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type CreateLoginTokenFromInvitationMutation = { __typename?: 'Mutation', createTokenFromInvitation: { __typename?: 'SuccessResponse', success: boolean, payload?: any | null } };

export type MyBrandOwnershipQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type MyBrandOwnershipQuery = { __typename?: 'Query', myBrandOwnership?: { __typename?: 'UserBrandOwnership', id: string, ownershipProof: UserBrandOwnershipProof } | null };

export type UserReviewCountQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserReviewCountQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, reviewCount: number } | null };

export type UserAchievementsQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserAchievementsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, reviewCount: number, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType, createdAt: string }> | null } | null };

export type UserKarmaQueryVariables = Exact<{
  username: Scalars['String'];
  reviewId?: InputMaybe<Scalars['Int']>;
}>;


export type UserKarmaQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, username: string, karma: number, level: number, karmaRequirementForPreviousLevel?: number | null, karmaRequirementForNextLevel?: number | null, latestKarmaEvents?: Array<{ __typename?: 'UserKarma', karmaEvent: string, amount: number, reviewId?: number | null, id: string, humanReadableName?: string | null }> | null } | null };

export type PublicUserQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type PublicUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, username: string, avatarFullPath?: string | null, firebaseUid: string, fullName?: string | null, firstName?: string | null, bio?: string | null, createdAt: string, jobTitle?: string | null, location?: string | null, role: UserRole, membershipLevel: MembershipLevel, verificationStatus: VerificationStatus, hasCompletedProfile: boolean, hasAddedAdditionalInformation: boolean, karma: number, level: number, reviewCount: number, karmaRequirementForPreviousLevel?: number | null, karmaRequirementForNextLevel?: number | null, socialAccounts: { __typename?: 'UserSocialAccounts', instagramUsername?: string | null, twitterUsername?: string | null, tiktokUsername?: string | null, linkedinUrl?: any | null }, achievements?: Array<{ __typename?: 'Achievement', id: string, type: AchievementType }> | null } | null };

export type VerifyPhoneNumberMutationVariables = Exact<{
  input: UserPhoneVerificationInput;
}>;


export type VerifyPhoneNumberMutation = { __typename?: 'Mutation', verifyPhoneNumber: { __typename?: 'User', id: string, verificationStatus: VerificationStatus } };

export type UnlinkPhoneNumberMutationVariables = Exact<{
  input: UserPhoneVerificationInput;
}>;


export type UnlinkPhoneNumberMutation = { __typename?: 'Mutation', unlinkPhoneNumber: { __typename?: 'User', id: string, verificationStatus: VerificationStatus } };

export type SitemapDataQueryVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type SitemapDataQuery = { __typename?: 'Query', sitemapData: { __typename?: 'SitemapData', brands: Array<{ __typename?: 'Brand', slug: string, updatedAt: string }>, stories: Array<{ __typename?: 'Story', slug?: string | null, updatedAt: string }>, categories: Array<{ __typename?: 'Category', slug: string }> } };
